<template>
  <div>
    <b-card no-body class="wr1-booking">
      <div class="pt-2 px-2">
        <!-- Table Top -->

        <b-button
          variant="primary"
          @click="
            chooseServiceType = '';
            activeTab = 1;
            request_quotation = {
              service_type: null,
            };
            stepNew = null;
            serviceType = null;
            isModalChooseService = true;
            $store.commit('masterData/SET_TRUCK_LIST', []);
          "
          class="btn-sm mb-2 round font-size-14"
          ><feather-icon icon="PlusIcon" /> New Booking</b-button
        >
        <!-- $bvModal.show('modal-create-booking-service'); -->

        <b-row>
          <b-col class="pb-2 tab-col-booking">
            <b-nav class="tab-booking">
              <b-nav-item
                v-for="i in menus"
                :key="i.id"
                @click="
                  loadBooking(i.id);
                  page = 1;
                "
                :active="i.active"
                :class="[{ active: i.active }, i.variable]"
              >
                {{ $t(i.text) }}({{ totalAllBooking[i.keyTotal] }})
              </b-nav-item>
            </b-nav>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col cols="12">
            <b-row class="d-flex item">
              <b-col cols="10" md="5" lg="8">
                <b-form-input
                  v-model="searchTerm"
                  class="d-inline-block round border-primary"
                  placeholder="Search"
                />
              </b-col>
              <div class="d-flex justify-content-center">
                <div
                  class="d-flex xet-width align-items-center position-relative"
                >
                  <feather-icon
                    icon="CalendarIcon"
                    class="icons-search"
                    size="16"
                  />
                  <flat-pickr
                    v-model="rangePicker"
                    :config="config"
                    class="form-control flat-picker bg-transparent border-0 shadow-none mt-0 w-full round date-mini border-primary"
                    placeholder="YYYY-MM-DD"
                  />
                </div>
              </div>
              <!-- <div>
                <div class="box-date mr-1">
                  <label>From</label>

                  <date-picker
                    ref="datePicker"
                    :clearable="false"
                    v-model="columnFilters.from"
                    type="date"
                    :title="columnFilters.from"
                    class="w-full round date-mini"
                    value-type="format"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select From"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY"
                    @close="handleOpenChange"
                  >
                  </date-picker>
                </div>
              </div> -->
              <!-- <div>
                <div class="box-date">
                  <label>To</label>

                  <date-picker
                    ref="datePicker"
                    :clearable="false"
                    v-model="columnFilters.to"
                    type="date"
                    :title="columnFilters.to"
                    class="w-full round date-mini"
                    value-type="format"
                    title-format="DD/MM/YY"
                    time-title-format="DD/MM/YY"
                    placeholder="Select To"
                    :show-time-panel="showTimePanel"
                    format="DD/MM/YY"
                    @close="handleOpenChange"
                  >
                  </date-picker>
                </div>
              </div> -->
            </b-row>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <vue-good-table
              ref="my-table"
              :columns="columns"
              class="vue-table-new"
              :key="tableDataKey"
              :rows="rows[this.menus.filter((i) => i.active)[0].variable]"
              :pagination-options="{
                enabled: true,
                dropdownAllowAll: false,
              }"
              :sort-options="{ enabled: false }"
              @on-row-dblclick="onRowDoubleClick"
              mode="remote"
              :row-style-class="rowStyleClassFn"
              @on-page-change="onPageChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
            >
              <template slot="column-filter" slot-scope="props">
                <date-picker
                  ref="date"
                  v-if="
                    props.column.field === 'pick_up_date' ||
                    props.column.field === 'delivery_date' ||
                    props.column.field === 'created_date'
                  "
                  :clearable="false"
                  type="date"
                  v-model="columnKeyword[props.column.field]"
                  class="w-full round date-mini date-table"
                  value-type="format"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  :show-time-panel="showTimePanel"
                  format="DD/MM/YY"
                  @close="handleOpenChange"
                >
                </date-picker>
              </template>

              <template slot="table-row" slot-scope="props">
                <div
                  class="test-container"
                  @contextmenu.prevent="onClickRightOpenMenu($event, props.row)"
                >
                  <!-- Column: Action -->
                  <span v-if="props.column.field === 'action'">
                    <div>
                      <!-- <feather-icon icon="EyeIcon" class="mr-50" /> -->
                      <EyeShow
                        v-b-tooltip.hover.top="'View'"
                        class="button-action"
                        @click="onRowDoubleClick(props)"
                      />
                      <!-- <BookingIcon
                        :class="[
                          props.row.accept_edit == 1 &&
                          props.row.status_id == 63
                            ? ''
                            : 'disabled-icon',
                          'button-action',
                        ]"
                        v-b-tooltip.hover.top="'Create New Shipment'"
                        @click="onRowDoubleClick(props)"
                      /> -->
                      <BookingIcon
                        v-b-tooltip.hover.top="'Update Booking Status'"
                        :class="[
                          props.row.accept_edit == 1 &&
                          [
                            7, 8, 9, 11, 13, 12, 25, 26, 27, 28, 29, 30, 31, 32,
                            33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44,
                          ].includes(props.row.status_id)
                            ? ''
                            : 'disabled-icon',
                          'button-action',
                        ]"
                        class="button-action"
                        @click="
                          () => {
                            props.row.accept_edit == 1 &&
                            [
                              7, 8, 9, 11, 13, 12, 25, 26, 27, 28, 29, 30, 31,
                              32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43,
                              44,
                            ].includes(props.row.status_id)
                              ? showViewAll(
                                  'modal-update-status',
                                  props.row,
                                  2,
                                  false
                                )
                              : '';
                          }
                        "
                      />

                      <!-- <BookingIcon
                        :class="[
                          props.row.accept_edit == 1 && props.row.status_id == 9
                            ? ''
                            : 'disabled-icon',
                          'button-action',
                        ]"
                        v-b-tooltip.hover.top="'Incurred cost'"
                        @click="
                          () => {
                            if (
                              props.row.accept_edit == 1 &&
                              props.row.status_id == 9
                            ) {
                              showViewAll(
                                'modal-confirm-incurred-cost',
                                props.row
                              );
                              incurredCost = '';
                            }
                          }
                        "
                      /> -->
                      <!-- <BookingIcon
                        class="button-action"
                        v-b-tooltip.hover="
                          props.row.status_id == 9
                            ? 'Confirm Payment'
                            : 'Confirm Booking'
                        "
                        :class="[
                          (props.row.accept_edit == 1 &&
                            props.row.status_id.toString() ===
                              $Utils.BOOKING_NAME.RECEIVED_BOOKING_REQUEST.toString()) ||
                          (props.row.accept_edit == 1 &&
                            props.row.status_id == 9 &&
                            menus.filter((i) => i.active)[0].text == 'Paid')
                            ? ''
                            : 'disabled-icon',
                          'button-action',
                        ]"
                        @click="
                          () => {
                            if (
                              (props.row.accept_edit == 1 &&
                                props.row.status_id.toString() ===
                                  $Utils.BOOKING_NAME.RECEIVED_BOOKING_REQUEST.toString()) ||
                              (props.row.accept_edit == 1 &&
                                props.row.status_id == 9 &&
                                menus.filter((i) => i.active)[0].text == 'Paid')
                            ) {
                              showViewAll(
                                'modal-confirm-booking',
                                props.row,
                                0
                              );
                            }
                          }
                        "
                      /> -->
                      <TrackAndTraceIcon
                        v-b-tooltip.hover.top="'Track And Trace'"
                        :class="[
                          (
                            $Utils.BOOKING_TAB.IN_TRANSIT +
                            ',' +
                            $Utils.BOOKING_TAB.DELIVERED +
                            ',' +
                            $Utils.BOOKING_TAB.PAYMENT
                          )
                            .split(',')
                            .includes(props.row.status_id.toString())
                            ? ''
                            : 'disabled-icon',
                          'button-action',
                        ]"
                        @click="
                          () => {
                            if (
                              (
                                $Utils.BOOKING_TAB.IN_TRANSIT +
                                ',' +
                                $Utils.BOOKING_TAB.DELIVERED +
                                ',' +
                                $Utils.BOOKING_TAB.PAYMENT
                              )
                                .split(',')
                                .includes(props.row.status_id.toString())
                            ) {
                              onHandlerViewTab(props.row, 6);
                            }
                          }
                        "
                      />
                    </div>
                  </span>

                  <span v-else-if="props.column.field == 'status'">
                    <span :class="checkStatusColor(props.row.status_id)">
                      {{ $Utils.BOOKING_STATUS[props.row.status_id] }}
                    </span>
                  </span>
                  <!-- <span v-else-if="props.column.field == 'total_vat'">
                    <span>
                      {{
                        $i18n.locale == "en"
                          ? $Utils.formatMooney(
                              props.formattedRow[props.column.field] /
                                exchangeRate,
                              "en-US"
                            ) + " USD"
                          : $Utils.formatMooney(
                              props.formattedRow[props.column.field],
                              "vi-VI"
                            ) + " VND"
                      }}
                    </span>
                  </span>
                  <span v-else-if="props.column.field == 'grand_total'">
                    <span>
                      {{
                        $i18n.locale == "en"
                          ? $Utils.formatMooney(
                              props.formattedRow[props.column.field] /
                                exchangeRate,
                              "en-US"
                            ) + " USD"
                          : $Utils.formatMooney(
                              props.formattedRow[props.column.field],
                              "vi-VI"
                            ) + " VND"
                      }}
                    </span>
                  </span> -->
                  <!-- <span v-else-if="props.column.field == 'Profit'">
                    <span>
                      {{
                        $i18n.locale == "en"
                          ? $Utils.formatMooney(
                              (props.row["total_vat"] -
                                props.row["grand_total"]) /
                                exchangeRate,
                              "en-US"
                            ) + " USD"
                          : $Utils.formatMooney(
                              props.row["grand_total"] - props.row["total_vat"],
                              "vi-VI"
                            ) + " VND"
                      }}
                    </span>
                  </span> -->

                  <!-- Column: Common -->
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </div>
              </template>

              <!-- pagination -->
              <template slot="pagination-bottom" slot-scope="">
                <div class="d-flex justify-content-between flex-wrap">
                  <div
                    class="d-flex align-items-center mb-0 mt-1 showing-pagination"
                  >
                    <!-- <span class="text-nowrap"> {{ $t("showing") }} </span> -->
                    <!-- <b-form-select
                      v-model="pageSize"
                      :options="['10', '50', '100']"
                      class="mx-1"
                      @input="(value) => onPerPageChange(value)"
                    /> -->
                    {{ $t("showing") }} {{ page }} to 10 of
                    {{ totalRecords }}
                    {{ $t("entries") }}
                    <!-- <span class="text-nowrap ml-1">
                       {{  $t("entries") }}
                    </span> -->
                  </div>
                  <div>
                    <b-pagination
                      :value="page"
                      :total-rows="totalRecords"
                      :per-page="pageSize"
                      first-number
                      last-class="last-class"
                      @click="tableDataKey++"
                      prev-class="prev-item"
                      hide-ellipsis
                      next-class="next-item"
                      ellipsis-class="ellipsis-item"
                      class="mt-1 mb-0"
                      @input="
                        (value) => {
                          return onPageChange(value);
                        }
                      "
                    >
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>

                      <template #ellipsis-text>
                        <div>...</div>
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
      <ul class="menuu" ref="menuRightBooking">
        <li class="li-i" @click="onHandleView">
          <feather-icon icon="EyeIcon" class="mr-50" />
          <span>View</span>
        </li>
        <li
          class="li-i"
          :disabled="stepNew == 'copy-booking'"
          @click="onHandleCopy"
        >
          <feather-icon icon="CopyIcon" class="mr-50" />
          <span>{{ stepNew == "copy-booking" ? "loading..." : "Copy" }}</span>
        </li>
      </ul>
    </b-card>
    <!-- basic modal -->
    <b-modal
      ref="Booking"
      size="xl"
      class="create-booking-modal"
      hide-footer
      id="modal-view-all"
      title="View All Booking Information"
      body-class="quotation-booking-view-all"
      @hide="hideModalAll"
    >
      <div slot="modal-title" v-if="request_quotation">
        <div class="d-flex justify-content-between align-content-center">
          <div v-if="request_quotation.id || booking.id || idToUse">
            View All Booking Information [{{
              this.request_quotation.id || this.booking.id || idToUse || ""
            }}]
          </div>
          <!-- 
         <div>
            <ChatWithWR1
              :isCustomer="false"
              :request_quotation="request_quotation"
            /> 
          </div> -->
        </div>
      </div>
      <b-card-text>
        <view-all
          ref="ViewAllBooking"
          :shipment_on_tms="shipment_on_tms"
          :shipment_on_fast="shipment_on_fast"
          :shipment_detail="shipment_detail"
          :activeTab.sync="activeTab"
          :request_quotation="request_quotation"
          :quotation="quotation"
          :booking="booking"
          :proc_code="proc_code"
          :status="status"
          :step="'view-quotation-booking'"
          :costs_info="costs_info"
          :track_trace="track_trace_status"
          :shipment="shipment"
          :booking_note="booking_note"
          :isUpdate="isUpdate"
          @AcceptBookingEvent="
            $bvModal.hide('modal-view-all');
            loadBooking(menus.filter((i) => i.active)[0].id);
          "
          @CancelBookingEvent="
            $bvModal.hide('modal-view-all');
            loadBooking(menus.filter((i) => i.active)[0].id);
          "
          @loadMyQuotation="loadBooking(menus.filter((i) => i.active)[0].id)"
          @EditBookingEvent="
            $bvModal.hide('modal-view-all');
            loadBooking(menus.filter((i) => i.active)[0].id);
          "
          :enableEditBooking="enableEditBooking"
          @NewShipmentToTMS="
            $bvModal.hide('modal-view-all');
            loadBooking(menus.filter((i) => i.active)[0].id);
          "
          @NewShipmentToFast="
            $bvModal.hide('modal-view-all');
            loadBooking(menus.filter((i) => i.active)[0].id);
          "
          @CustomerBookingEvent="
            $bvModal.hide('modal-view-all');
            loadBooking(menus.filter((i) => i.active)[0].id);
          "
          @RequestAnUpdateEvent="
            $bvModal.hide('modal-view-all');
            loadBooking(menus.filter((i) => i.active)[0].id);
          "
        />
      </b-card-text>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      id="confirmOut"
      title="Close Form"
      @ok="confirmOut"
      v-model="valueConfirmOut"
      @close="valueConfirmOut = false"
    >
      <b-card-text>
        <validation-observer ref="cancelRules">
          You have made changes to the form data! Are you sure you want to exit
          without saving?
        </validation-observer>
      </b-card-text>
    </b-modal>
    <b-modal
      id="modal-confirm-incurred-cost"
      title="Incurred cost"
      @ok="handConfirmIncurredCost"
      ok-title="Confirm"
      :size="booking == null ? 'xl' : ''"
    >
      <div>
        <b-card-text class="text-center">
          <p class="pt-1">Are you sure to confirm this Incurred cost</p>
          <h4 v-if="booking != null" class="text-primary">
            {{ booking.id }}
          </h4>
        </b-card-text>
        <b-card-text>
          <validation-observer ref="reqCostRules">
            <validation-provider
              name="Incurred cost"
              #default="{ errors }"
              rules="required"
            >
              <b-form-input
                type="number"
                :state="errors.length > 0 ? false : null"
                v-model="incurredCost"
                placeholder="Enter Incurred cost"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </validation-observer>
        </b-card-text>
      </div>
    </b-modal>
    <b-modal
      id="modal-confirm-booking"
      body-class="quotation-booking-view_confirm"
      :title="
        booking != null
          ? booking.status_id == 9
            ? 'Confirm Payment'
            : 'Confirm booking'
          : 'Confirm booking'
      "
      @ok="handConfirmBooking"
      ok-title="Confirm"
      size="xl"
    >
      <!-- <div v-if="booking !== null">
        <b-card-text class="text-center" v-if="booking.status_id == 9">
          <p class="pt-1">Are you sure to confirm payment this booking</p>
          <h4 v-if="booking != null" class="text-primary">
            {{ booking.id }}
          </h4>
        </b-card-text>
        <div v-else>
          <b-card-text>
            <validation-observer ref="reqanupdateRules">
              <validation-provider #default="{ errors }" rules="required">
                <Select2
                  :disabled="
                    userData.userType == $Utils.CONSTANTS.USER_TYPE_O.Admin
                      ? false
                      : true
                  "
                  v-model="booking.booking_sale_id"
                  :options="sales_list"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </validation-observer>
          </b-card-text>
          <b-card-text class="text-center">
            <p class="pt-1">Are you sure to confirm this booking</p>
            <h4 v-if="booking != null" class="text-primary">
              {{ booking.id }}
            </h4>
          </b-card-text>
        </div>
      </div> -->
      <b-card-text>
        <!-- <create-quotation
          :request_quotation="request_quotation"
          :readonly="false"
          ref="quotationRef"
          step="booking"
        /> -->
        <b-tabs pills card>
          <b-tab
            title="
             Booking Request 
            "
            :active="activeTab == 0"
            v-if="request_quotation != null"
            @click="activeTab = 0"
          >
            <keep-alive>
              <b-card-text>
                <vue-perfect-scrollbar
                  :settings="{
                    maxScrollbarLength: 150,
                    suppressScrollX: true,
                  }"
                  style="max-height: 73vh"
                  class="scrollable-container scroll-area"
                >
                  <keep-alive>
                    <NewBookingSale
                      isCustomer
                      :view_RequestQuotation="request_quotation"
                      className="mybooking-online"
                      :step="'view-quotation-booking'"
                      :readonly="true"
                      v-if="
                        request_quotation &&
                        request_quotation.service_type &&
                        request_quotation.service_type.toString() == '3'
                      "
                    />
                    <NewContainerTruckSale
                      isCustomer
                      :view_RequestQuotation="request_quotation"
                      className="mybooking-online"
                      :step="'view-quotation-booking'"
                      :readonly="true"
                      v-if="
                        request_quotation &&
                        request_quotation.service_type &&
                        request_quotation.service_type.toString() == '5'
                      "
                    />
                    <NewVanTruckSale
                      isCustomer
                      :view_RequestQuotation="request_quotation"
                      className="mybooking-online"
                      :step="'view-quotation-booking'"
                      :readonly="true"
                      v-if="
                        request_quotation &&
                        request_quotation.service_type &&
                        request_quotation.service_type.toString() == '6'
                      "
                    />
                  </keep-alive>

                  <!-- <request-quotation
                  isCustomer
                  :view_RequestQuotation="request_quotation"
                  className="mybooking-online"
                  :step="'view-quotation-booking'"
                  :readonly="true"
                /> -->
                </vue-perfect-scrollbar>
              </b-card-text>
            </keep-alive>
          </b-tab>
          <!-- RequestBookingNote -->
          <!-- <b-tab
            title="Booking Note"
            :active="activeTab == 1"
            @click.prevent="activeTab = 1"
            :disabled="stepTab < 1"
            v-if="
              (request_quotation != null &&
                booking_note != null &&
                request_quotation.service_type == 'LCL') ||
              request_quotation.service_type == '3'
            "
          >
            <b-card-text>
              <vue-perfect-scrollbar
                :settings="{
                  maxScrollbarLength: 150,
                  suppressScrollX: true,
                }"
                style="max-height: 70vh"
                class="scrollable-container scroll-area"
              >
                <RequestBookingNote
                  @clickActiveTab="activeTab = 1"
                  v-model="booking_note"
                  :request_quotation="request_quotation"
                  :bookingSchedule="true"
                  :readonly="false"
                />
              </vue-perfect-scrollbar>
            </b-card-text>
          </b-tab> -->

          <!-- :disabled="stepTab < 2" -->
          <b-tab
            title="Quote"
            :active="activeTab == 2"
            @click="
              () => {
                const temp =
                  this.quotations.find(
                    (e) => e.id == this.request_quotation.quotation
                  ).quotation_info || {};
                this.quotation = JSON.parse(temp);
                this.activeTab = 2;
                this.stepTab = 2;
                this.reloadQua++;
              }
            "
          >
            <!-- {{ quotation }} -->
            <b-card-text>
              <create-quotation
                :request_quotation="request_quotation"
                :view_quotation="quotation"
                :booking="booking"
                :key="reloadQua"
                @CancelBooking="
                  $bvModal.hide('modal-confirm-booking');
                  loadBooking(menus.filter((i) => i.active)[0].id);
                "
                @CancelBookingEvent="
                  $bvModal.hide('modal-confirm-booking');
                  loadBooking(menus.filter((i) => i.active)[0].id);
                "
                :readonly="booking != null ? true : false"
                ref="quotationRef"
                step="booking"
              />
            </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card-text>
      <template #modal-footer>
        <!-- <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-confirm-booking')"
        >
          Cancel
        </b-button> -->
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="() => (ModalReject = true)"
        >
          Reject
        </b-button>
        <!-- <b-button variant="primary" size="sm" v-if="booking == null" @click="handConfirmBookingNoPrice"
          class="btn round">
          Without price
        </b-button> -->
        <b-button
          variant="primary"
          size="sm"
          @click="handConfirmBooking"
          class="btn btn-cancel-custom"
        >
          Confirm booking
        </b-button>
      </template>
    </b-modal>
    <b-modal
      v-model="ModalReject"
      no-close-on-backdrop
      @close="ModalReject = false"
      dialog-class="new-dialog-modal-reject"
      header-class="new-modal-reject"
      title=""
      hide-footer
    >
      <template #modal-title>
        <div class="header-title-reject">Reject</div>
      </template>
      <div>
        <b-form-input
          type="text"
          class="inputReject"
          v-model="rejectReason"
          placeholder="Please provide the reason for rejecting the booking"
          required
        ></b-form-input>
      </div>
      <div class="divReject">
        <b-button
          variant="primary"
          size="sm"
          @click="handleRejectBooking"
          class="btn round btnReject"
        >
          Send
        </b-button>
      </div>
    </b-modal>
    <b-modal
      id="modal-create-booking"
      @hide="stepNew = null"
      no-close-on-backdrop
      body-class="quotation-booking-view"
      title="Create Booking"
      size="xl"
      @ok="handNewCustomerBooking"
      @close="
        () => {
          valueModal = false;
          this.isCopy = false;
        }
      "
      hide-footer
      @ok-clicked-van="closeModal"
    >
      <template #modal-title>
        <div class="header-title text-white text-uppercase h4">
          Create a new booking in just a few steps
        </div>
        <div class="header-sub text-white">
          Please fill in the data completely and correctly to receive the
          fastest booking confirmation
        </div>
      </template>
      <b-tabs pills card>
        <b-tab
          title="Booking Request"
          @click="
            () => {
              activeTab = 1;
            }
          "
          :active="activeTab == 1"
        >
          <b-card-text>
            <request-quotation
              ref="requestQuotationRef"
              :chooseServiceType="chooseServiceType"
              :isCustomer="false"
              :view_RequestQuotation="request_quotation"
              :readonly="false"
              :isCopy="isCopy"
              step="booking"
              @ok-clicked-van="closeModal"
              :readonlyService="chooseServiceType != ''"
              @onServiceType="onServiceType"
              :key="reload"
            />
            <div class="container_btn">
              <button class="custom_btn_booking" @click="showModalComingSoon">
                Preview
              </button>
              <button
                @click="handNewCustomerBooking"
                class="custom_btn_booking"
              >
                Submit
              </button>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab
          title="Quote"
          v-if="
            containsKey(serviceType, 'service_type') && isServiceType == true
          "
          @click="
            () => {
              activeTab = 2;
              reloadQua++;
            }
          "
          :active="activeTab == 2"
        >
          <b-card-text>
            <create-quotation
              :readonly="false"
              @checkRequestBooking="handCheckUpdate"
              :request_quotation="request_quotation"
              :view_quotation="quotation"
              :copy="stepNew == 'copy-booking'"
              step="booking"
              :booking="
                stepNew == 'copy-booking'
                  ? request_quotation.quotation
                  : quotation
              "
              @ok-clicked-van="closeModal"
              :key="reloadQua"
              :serviceType="stepNew == 'copy-booking' ? null : serviceType"
              ref="quotationRef"
            />
          </b-card-text>
          <div class="container_btn" v-if="step == 1">
            <button class="custom_btn_booking">Preview</button>
            <button @click="handNewCustomerBooking" class="custom_btn_booking">
              Submit
            </button>
          </div>
        </b-tab>
      </b-tabs>

      <template #modal-footer>
        <b-button
          variant="secondary"
          size="sm"
          class="btn round"
          @click="$bvModal.hide('modal-create-booking')"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="handNewCustomerBooking"
          class="btn round"
        >
          Send a Booking
        </b-button>
      </template>
    </b-modal>
    <!-- <b-modal
            id="modal-create-booking-sale-new"
            title="Create Booking"
            size="xl"
            class="create-booking-modal"
            hide-footer
        >
            <template #modal-title>
                <div class="header-title text-white text-uppercase h4">
                    Create a new booking in just a few steps
                </div>
                <div class="header-sub text-white">
                    Please fill in the data completely and correctly to receive
                    the fastest booking confirmation
                </div>
            </template>
            <b-card-text>
                <NewBookingSale :readonly="false" />
            </b-card-text>
        </b-modal> -->
    <b-modal
      v-model="ModalComingSoon"
      no-close-on-backdrop
      @close="ModalComingSoon = false"
      dialog-class="new-dialog-modal-reject"
      header-class="new-modal-reject"
      title=""
      hide-footer
    >
      <template #modal-title>
        <div class="header-title-reject">COMING SOON</div>
      </template>
      <div class="custom_text_coming">THIS FEATURE IS COMING SOON</div>
    </b-modal>
    <b-modal
      id="modal-update-status"
      :title="update_status_title"
      size="lg"
      hide-footer
    >
      <b-card-text>
        <v-jstree
          :data="track_trace_status"
          show-checkbox
          value-field-name="id"
          multiple
          allow-batch
          whole-row
          @item-click="updateBookingStatus"
        ></v-jstree>
      </b-card-text>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      id="modal-update-status-confirm"
      title="Confirm Update Booking Status"
      v-if="shipment != null"
      @ok="handUpdateBookingStatus"
      @cancel="handCancelUpdateBookingStatus"
      @hidden="handCancelUpdateBookingStatus"
    >
      <b-card-text>
        <validation-observer ref="updateStatusRules">
          <b-row>
            <b-col cols="12">
              <validation-provider #default="{ errors }" rules="required">
                <b-form-group>
                  <label>Date Time</label>
                  <flat-pickr
                    class="form-control"
                    :state="errors.length > 0 ? false : null"
                    :disabled="
                      userData.userType ==
                      $Utils.CONSTANTS.USER_TYPE_O.Admin_Sale
                        ? true
                        : false
                    "
                    :config="{
                      dateFormat: 'd/m/Y H:i',
                      enableTime: true,
                    }"
                    v-model="current_shipment_status.date_"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" v-if="isOnBoard">
              <validation-provider #default="{ errors }" rules="required">
                <label>HBL</label>
                <b-form-input
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  v-model="current_shipment_status.HBL"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </b-card-text>
    </b-modal>

    <!-- modal-create-booking-service -->

    <b-modal
      no-close-on-backdrop
      id="modal-create-booking-service"
      title="Choose a booking service"
      @ok="handChooseService"
    >
      <b-card-text>
        <validation-observer ref="refChooseService">
          <b-row>
            <b-col cols="12">
              <validation-provider
                name="Service Type"
                #default="{ errors }"
                rules="required"
              >
                {{ service_types }}
                <b-form-group>
                  <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    placeholder="Select Service Type"
                    v-model="chooseServiceType"
                    :options="service_types"
                  />
                  <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                  }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </validation-observer>
      </b-card-text>
    </b-modal>
    <!-- LongTN 29/06/2023 -->
    <ChooseServices
      :key="isModalChooseService"
      @select="handSelectService"
      v-model="isModalChooseService"
    />
    <!-- End LongTN 29/06/2023 -->

    <ScheduleListBooking
      v-model="valueModal"
      :key="valueModal"
      @EditBookingEvent="
        $bvModal.hide('modal-view-all');
        loadBooking(menus.filter((i) => i.active)[0].id);
      "
      :currentItem="request_quotation"
      :step="stepNew == 'copy-booking' ? 10 : 1"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ScheduleListBooking from "@/views/wr1/schedule-list/ScheduleListBooking.vue";
import draggable from "vuedraggable";
import vSelect from "vue-select";
import Select2 from "v-select2-component";
import ChatWithWR1 from "./quotation/ChatWithWR1.vue";
import ChooseServices from "./V2/ChooseServices";
import {
  GetLastBookingOfVanCont,
  GetBookingDetail,
  UpdateStatusBooking,
} from "@/api";
import {
  BCard,
  BRow,
  BCardText,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BNav,
  BNavItem,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BModal,
  BFormCheckbox,
  BFormGroup,
  VBTooltip,
  BFormSelect,
  BTabs,
  BTab,
} from "bootstrap-vue";
import useJwt from "@/auth/jwt/useJwt";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { VueGoodTable } from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import RequestQuotation from "./quotation/RequestQuotation.vue";
import CreateQuotation from "./quotation/CreateQuotation.vue";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { $ctx } from "@themeConfig";
import VJstree from "vue-jstree";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "@/@core/components/flatpickr-airbnb.css";
import { mapState } from "vuex";
import mixin from "@/mixin/mixin";
import trackTrace from "@/mixin/trackTrace.js";
import { checkDateToFormat, checkDateTimeToFormat } from "@/utils/format";
import EyeShow from "@/assets/images/icons/file-icons/Hiện.svg?external";
import TrackAndTraceIcon from "@/assets/images/icons/file-icons/TrackAndTrace.svg?external";
import BookingIcon from "@/assets/images/icons/file-icons/Booking.svg?external";
import NewBookingSale from "@/views/wr1/V2/NewBookingSale";
import NewVanTruckSale from "@/views/wr1/V2/NewVanTruckSale";
import NewContainerTruckSale from "@/views/wr1/V2/NewContainerTruckSale";
import ListGroupHorizontal from "../components/list-group/ListGroupHorizontal.vue";

export default {
  mixins: [mixin, trackTrace],
  props: {
    idBooking: { default: null },
    status: { default: null },
  },
  components: {
    ChooseServices,
    draggable,
    TrackAndTraceIcon,
    BookingIcon,
    EyeShow,
    RequestBookingNote: () =>
      import("@/views/wr1/booking-note/RequestBookingNote.vue"),
    NewContainerTruckSale,
    NewVanTruckSale,
    ScheduleListBooking,
    NewBookingSale,
    ChatWithWR1,
    BCard,
    BRow,
    BCol,
    BCardText,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    FeatherIcon,
    BModal,
    BFormGroup,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    Select2,
    VueGoodTable,
    BFormSelect,
    RequestQuotation: () => import("./quotation/RequestQuotation.vue"),
    BTabs,
    BTab,
    CreateQuotation: () => import("./quotation/CreateQuotation.vue"),
    BNav,
    BNavItem,
    ViewAll: () => import("./ViewAll.vue"),
    vueDropzone: vue2Dropzone,
    VJstree,
    flatPickr,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },

  data() {
    return {
      rangePicker: `${moment()
        .subtract(7, "d")
        .format("DD-MM-YYYY")} to ${moment().format("DD-MM-YYYY")}`,
      config: {
        mode: "range",
        altFormat: "d-m-Y",
        altInput: true,
      },
      isCopy: false,
      idToUse: null,
      step: { default: null },
      valueConfirmOut: false,
      ModalComingSoon: false,
      ModalReject: false,
      rejectReason: null,
      reload: 1,
      reloadQua: 1,
      isModalChooseService: false,
      columnKeyword: {},
      showTimePanel: false,
      columnFilters: {
        to: moment().format("DD/MM/YY"),
        from: moment().subtract(7, "days").format("DD/MM/YY"),
      },
      moment,
      config: {
        mode: "range",
        altFormat: "d-m-Y",
        altInput: true,
        dateFormat: "d-m-Y",
      },
      stepNew: null,
      rowSelectCopy: null,
      valueModal: false,
      chooseServiceType: "",
      totalAllBooking: {},
      isServiceType: true,
      serviceType: null,
      tableDataKey: 0,
      stepTab: 0,
      incurredCost: "",
      userData: JSON.parse(localStorage.getItem("userData")),
      menus: [
        //         Paid: (...)
        // all_booking: (...)
        // delivered: (...)
        // booking_approval: (...)
        // canceled: (...)
        // completed: (...)
        // in_process: (...)
        // new_booking: (...)
        // in_transit: (...)

        //  {
        //    id: "5",
        //    text: "New booking",
        //    keyTotal: "new_booking",
        //    variable: "newBooking",
        //  },
        {
          id: "61,5,17,16,6,63,62,7,31,37,38,39,40,41,42,43,44,36,35,34,25,26,27,28,29,30,32,33,8,11,9,13,10,12",
          text: "All",
          active: true,
          keyTotal: "all_booking",
          variable: "all",
        },

        {
          id: "61,5,17,16,6",
          text: "In Process",
          keyTotal: "in_process",
          variable: "inProcess",
        },
        {
          id: "63,62,7",
          text: "Booking Approval",
          keyTotal: "booking_approval",

          variable: "bookingApproval",
        },
        {
          id: "31,37,38,39,40,41,42,43,44,36,35,34,25,26,27,28,29,30,32,33",
          text: "In Transit",
          keyTotal: "in_transit",
          variable: "inTransit",
        },
        {
          id: "8",
          text: "Delivered",
          keyTotal: "delivered",
          variable: "delivered",
        },
        {
          id: "11,9,13",
          text: "Paid",
          keyTotal: "payment",
          variable: "paid",
        },
        {
          id: "10,12",
          text: "Canceled",

          keyTotal: "cancelled",
          variable: "canceled",
        },
      ],
      dropzoneOptions: {
        url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
        addRemoveLinks: !this.readonly,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
        clickable: !this.readonly,
      },
      booking: {},
      quotation_status: 0,
      quotation: null,
      shipment: null,
      shipment_on_fast: null,
      shipment_on_tms: null,
      costs_info: {},
      current_shipment_status: {
        date_: moment(new Date()).format("DD/MM/YYYY HH:mm"),
      },
      isOnBoard: false,
      update_status_title: "Update Booking Status",
      pageLength: 10,
      dir: false,

      columns: [
        {
          label: "Customer",
          thClass: "text-uppercase w-pic-customer",
          tdClass: "text-center",
          field: "customer_company_name",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "Pic customer",
          thClass: "text-uppercase w-pic-customer",
          field: "customer_name",
          tdClass: "text-center",

          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "Status",
          field: "status",
          thClass: "text-uppercase w-status",
          tdClass: "bg-status text-center w-status",

          width: "100px",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "Service",
          thClass: "text-uppercase",
          field: "service_type",
          tdClass: "text-center w-service",

          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "BOOKING NO",
          thClass: "text-uppercase  w-booking-no",
          field: "booking_no",
          tdClass: "text-center",

          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "POL",
          thClass: "text-uppercase w-pol",
          tdClass: "text-center",

          field: "pol",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "POD",
          thClass: "text-uppercase w-pod",
          tdClass: "text-center",

          field: "pod",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },

        {
          label: "Pick up place",
          field: "pickup_name",
          tdClass: "text-center ",

          thClass: "text-uppercase w-pod",

          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "Delivery place",
          field: "delivery_name",
          tdClass: "text-center",

          thClass: "text-uppercase w-delivery-place",

          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "Container No.",
          thClass: "text-uppercase w-delivery-place",
          tdClass: "text-center",
          field: "container_no",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "ETD",
          thClass: "text-uppercase w-delivery-place",
          tdClass: "text-center",
          field: "etd",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "ETA",
          thClass: "text-uppercase w-delivery-place",
          tdClass: "text-center",
          field: "eta",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "Pick up date",
          tdClass: "text-center",
          field: "pick_up_date",
          thClass: "text-uppercase w-delivery-place",

          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          label: "Delivery date",
          field: "delivery_date",
          thClass: "text-uppercase w-delivery-place",
          tdClass: "text-center",

          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },

        {
          label: "HBL No.",
          thClass: "text-uppercase w-delivery-place",
          field: "HBL",
          tdClass: "text-center",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          thClass: "text-uppercase  w-delivery-place",
          tdClass: "text-center",
          label: "Transit Port",
          field: "consignee_acronym",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          thClass: "text-uppercase  w-create-date",
          tdClass: "text-center",
          label: "Created Date",
          field: "created_date",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          thClass: "text-uppercase  w-create-date",
          tdClass: "text-center",
          label: "Sale name",
          field: "sale_name",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          thClass: "text-uppercase  w-create-date",
          tdClass: "text-center",
          label: "Created by",
          field: "created_by",
          filterOptions: {
            enabled: true,
            placeholder: " ",
          },
        },
        {
          thClass: "text-uppercase",
          tdClass: "text-center w-action",
          label: "Action",
          field: "action",
        },
      ],
      rows: {
        newBooking: [],
        inProcess: [],
        bookingApproval: [],
        inTransit: [],
        delivered: [],
        completed: [],
        canceled: [],
        paid: [],
        all: [],
      },
      searchTerm: "",
      page: 1,
      pageSize: 10,
      totalRecords: 0,
      customer_id: "",
      quotation: null,
      request_quotation: null,
      proc_code: null,
      activeTab: 0,
      enableEditBooking: false,
      status: null,
      lists: [
        { id: "2.1", text: "Release Booking", group: 1, idStatus: 63 },
        {
          id: "2.2",
          text: "Received Revise Request",
          group: 1,
          idStatus: 62,
        },
        {
          id: "2.3",
          text: "Planned Transportation",
          group: 1,
          idStatus: 7,
        },

        // { id: "3.0", text: "Truck Information", group: 2 },
        { id: "3.1", text: "Empty Picked Up", group: 2, idStatus: 25 },
        { id: "3.2", text: "Arrived At The Warehouse", group: 2, idStatus: 26 },
        { id: "3.3", text: "Picked Up Cargo", group: 2, idStatus: 27 },
        {
          id: "3.4",
          text: "Delivered Cargo To The Port",
          group: 2,
          idStatus: 28,
        },
        {
          id: "3.5",
          text: "Reached The Receiving Location",
          group: 2,
          idStatus: 29,
        },
        { id: "3.6", text: "Picked Up Cargo", group: 2, idStatus: 30 },
        {
          id: "3.7",
          text: "Reached The Delivery Location",
          group: 2,
          idStatus: 31,
        },

        { id: "3.8", text: "Delivered Cargo", group: 2, idStatus: 32 },
        { id: "3.9", text: "Cargo Loaded", group: 2, idStatus: 33 },
        {
          id: "3.10",
          text: "Arrived Destination Port",
          group: 2,
          idStatus: 34,
        },
        { id: "3.11", text: "Release", group: 2, idStatus: 35 },
        {
          id: "3.12",
          text: "Reached The Receiving Location",
          group: 2,
          idStatus: 36,
        },
        { id: "3.13", text: "Picked Up Cargo", group: 2, idStatus: 37 },
        {
          id: "3.14",
          text: "Reached The Delivery Location",
          group: 2,
          idStatus: 38,
        },
        { id: "3.15", text: "Delivered Cargo", group: 2, idStatus: 39 },
        { id: "3.16", text: "Cnee Has Received Cargo", group: 2, idStatus: 40 },
        { id: "3.17", text: "Picked Up Cargo", group: 2, idStatus: 41 },
        {
          id: "3.18",
          text: "Arrived At The Warehouse",
          group: 2,
          idStatus: 42,
        },
        { id: "3.19", text: "Delivered Cargo", group: 2, idStatus: 43 },
        { id: "3.20", text: "Empty Return", group: 2, idStatus: 44 },

        { id: "4.1", text: "Delivered", group: 3, idStatus: 8 },

        { id: "5.1", text: "Unpaid", group: 4, idStatus: 9 },
        { id: "5.2", text: "Paid", group: 4, idStatus: 11 },
        { id: "5.3", text: "Refund", group: 4, idStatus: 13 },
      ],
      shipment_detail: {},
    };
  },

  async created() {
    this.$loading.show();

    this.$store.dispatch("masterData/FETCH_ALL");
  },
  computed: {
    ...mapState("masterData", ["sales", "service_types", "quotations"]),

    exchangeRate: function () {
      return this.$store.getters["masterData/exchangeRate"];
    },
    objectId() {
      return this.$store.getters["tabView/objectId"];
    },
    objectType: function () {
      return this.$store.getters["tabView/objectType"];
    },
    sales_list() {
      return this.sales;
    },
  },
  mounted() {
    // this.$bvModal.show("modal-choose-service");

    // this.$bvModal.show("modal-create-container-truck-sale");
    // this.$bvModal.show("modal-create-booking-sale-new");

    //  this.objectType = this.$store.getters["tabView/objectType"]

    this.idToUse = JSON.parse(localStorage.getItem("idBooking")) || "";

    const menu = this.$refs.menuRightBooking;
    window.addEventListener("click", () => (menu.style.visibility = "hidden"));
    this.searchTerm = this.idBooking;

    const data = this.$store.getters["tabView/tabBooking"];

    this.loadBooking(data);

    // useJwt.get("masterData?data=Saler", {}).then((response) => {
    //   this.sales_list = this.formatOption(response.data.result);
    // });
    this.shipment_origin = JSON.parse(JSON.stringify(this.shipment));

    if (this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin) {
      this.columns.splice(0, 0, {
        label: "ORDER ID",
        thClass: "text-uppercase  w-delivery-place ",
        tdClass: "text-center",
        field: "id",
        filterOptions: {
          enabled: true,
          placeholder: " ",
        },
      });
      // this.columns.splice(17, 0, {
      //   thClass: "text-uppercase",
      //   label: "Profit",
      //   field: "Profit",
      //   filterOptions: {
      //     enabled: true,
      //     placeholder: " ",
      //   },
      // });
      // this.columns.splice(18, 0, {
      //   thClass: "text-uppercase",
      //   label: "Sales WR1",
      //   field: "sale_name",
      //   filterOptions: {
      //     enabled: true,
      //     placeholder: " ",
      //   },
      // });
    } else {
      this.columns.splice(0, 0, {
        label: "ORDER ID",
        thClass: "text-uppercase  w-delivery-place",
        field: "id",
        tdClass: "text-center",

        filterOptions: {
          enabled: true,
          placeholder: " ",
        },
      });
      // this.columns.splice(17, 0, {
      //   thClass: "text-uppercase",
      //   label: "Selling Rate",
      //   field: "total_vat",
      //   filterOptions: {
      //     enabled: true,
      //     placeholder: "",
      //   },
      // });
      // this.columns.splice(18, 0, {
      //   thClass: "text-uppercase",
      //   label: "Buying Rate",
      //   field: "grand_total",
      //   filterOptions: {
      //     enabled: true,
      //     placeholder: " ",
      //   },
      // });
    }
  },
  watch: {
    rangePicker: function (newVal, oldVal) {
      if (newVal != oldVal) {
        const newDate = typeof newVal == "string" ? newVal.split(" ") : "";
        if (newDate && newDate[2]) {
          const arr2 = newDate[2];
          this.columnFilters.from = moment(newDate[0], "DD-MM-YYYY").format(
            "DD/MM/YY"
          );
          this.columnFilters.to = moment(arr2, "DD-MM-YYYY").format("DD/MM/YY");
        }
      }
    },
    columnKeyword: {
      handler(val) {
        this.page = 1;
        this.loadBooking(this.menus.filter((i) => i.active)[0].id);
        handleOpenChange();
      },
      deep: true,
    },
    "columnFilters.from"(n) {
      if (n && this.columnFilters.to) {
        this.page = 1;

        this.loadBooking(this.menus.filter((i) => i.active)[0].id);
      }
    },
    "columnFilters.to"(n) {
      if (n && this.columnFilters.from) {
        this.page = 1;

        this.loadBooking(this.menus.filter((i) => i.active)[0].id);
      }
    },

    valueModal(n) {
      if (n == false) {
        this.stepNew = null;
      }
    },
    quotation_status: function (n, o) {
      this.loadBooking(this.menus.filter((i) => i.active)[0].id);
    },
    searchTerm(val, oldVal) {
      val == "" ? this.$store.commit("tabView/SET_OBJECT_ID", null) : "";
      this.page = 1;
      this.loadBooking(this.menus.filter((i) => i.active)[0].id);
    },
    objectId(val, oldVal) {
      // console.log("objectId", val);
      this.searchTerm = val;
    },
  },
  methods: {
    handleCustomFilter(value) {
      console.log(value);
      // filtering logic here
    },
    track() {
      this.$gtag.pageview("MyWr1Booking");
    },
    showModalComingSoon() {
      this.ModalComingSoon = true;
    },
    closeModal() {
      this.valueModal = false;
      this.$bvModal.hide("modal-create-booking");
    },
    async handSelectService(type) {
      // Chọn loại booking để tạo mới New booking
      this.chooseServiceType = type.toString();
      this.rowSelectCopy = null;
      if (this.chooseServiceType.toString() == "3") {
        this.request_quotation = {
          showAddMore: [
            {
              id: 1,
              hasDelete: false,
              showAddMoreLine: [
                {
                  id: 2,
                  hasDelete: false,
                  gross_weight: null,
                  volume: null,
                  packages: null,
                  dimension: { lenght: null, width: null, height: null },
                },
              ],
              package_type: null,
              total_packages: 0,
              gross_weight_total: 0,
              volume_total: 0,
            },
          ],
          valueVan: [
            {
              id: 1,
              hasDelete: false,
              truck_type: null,
              quantity: null,
              VanLine: [
                {
                  id: 2,
                  hasDelete: false,
                  commodity_type: null,
                  commodity: null,
                  total_gross_weight: null,
                  total_package: null,
                  total_volume: null,
                },
              ],
            },
          ],
          valueContainer: [
            {
              id: 1,
              hasDelete: false,
              commodity_type: null,
              commodity: null,
              container_type: null,
              quantity: null,
              total_gross_weight: null,
            },
          ],
          paymentTerms: null,
          pickUpContact: { name: null, phone: null },
          deliveryContact: { name: null, phone: null },
          isPickUpInput: null,
          eta: null,
          quotation: null,
          etd: null,
          customs_other_service_type: null,
          has_container_trucking: null,
          isHideShows: false,
          isHideShowPks: false,
          other_pickup_location: null,
          other_delivery_location: null,
          pickup_location: null,
          delivery_location: null,
          other_pickup_region: null,
          other_delivery_region: null,
          pickup_region: null,
          delivery_region: null,
          company_id: null,
          customer_id: null,
          service_type: "5",
          pod_port: null,
          pol_port: null,
          incoterms: null,
          cont_type: null,
          goods_type: null,
          package_type: null,
          transport_type: null,
          deport: null,
          business_type: null,
          so_luong: null,
          trong_luong: null,
          mo_ta: null,
          volume: null,
          from_date: null,
          to_date: null,
          other_service: null,
          notes: null,
          so_khoi: null,
          so_kien: null,
          shipping_line: null,
          place_of_stuffing: null,
          totalChargeWeight: null,
          size_: { length_: null, width_: null, height_: null },
          cargo_ready: "21/09/23 14:32",
          customs_addr: null,
          hs_code: null,
          pickUpDateTime: null,
          pickUpDate: null,
          pickUpTime: null,
          deliveryDateTime: null,
          deliveryDate: null,
          deliveryTime: null,
          cargo_booking: null,
          carrier: null,
          cargo_closing_dateTime: null,
          cargo_closing_date: null,
          cargo_closing_time: null,
          cargo_details_commodity_truck: [
            { id: 1, hasDelete: false, commodity_type: null, commodity: null },
          ],
          cargo_details_container_truck: [
            {
              id: 2,
              hasDelete: false,
              container_type: null,
              quantity: null,
              total_gross_weight: null,
            },
          ],
          additional_custom: false,
          additional_custom_input: null,
          has_other_custom: false,
          place_of_custom: null,
          HS_code_truck: null,
          customs_type: null,
          notes_truck: null,
          door_contact_pick_up: { name: "", phone: "", email: "" },
          door_contact_delivery: { name: "", phone: "", email: "" },
          inland_contact_pick_up: { name: "", phone: "", email: "" },
          inland_contact_delivery: { name: "", phone: "", email: "" },
        };

        this.stepNew = null;

        this.serviceType = null;
        this.request_quotation.service_type_id = this.chooseServiceType;
        this.request_quotation.service_type_id = "3";
        this.request_quotation.service_type = "3";
        this.onServiceType(this.request_quotation);
        this.valueModal = true;
        this.isModalChooseService = false;
      } else if (this.chooseServiceType.toString() == "5") {
        this.request_quotation = {
          showAddMore: [
            {
              id: 1,
              hasDelete: false,
              showAddMoreLine: [
                {
                  id: 2,
                  hasDelete: false,
                  gross_weight: null,
                  volume: null,
                  packages: null,
                  dimension: { lenght: null, width: null, height: null },
                },
              ],
              package_type: null,
              total_packages: 0,
              gross_weight_total: 0,
              volume_total: 0,
            },
          ],
          valueVan: [
            {
              id: 1,
              hasDelete: false,
              truck_type: null,
              quantity: null,
              VanLine: [
                {
                  id: 2,
                  hasDelete: false,
                  commodity_type: null,
                  commodity: null,
                  total_gross_weight: null,
                  total_package: null,
                  total_volume: null,
                },
              ],
            },
          ],
          valueContainer: [
            {
              id: 1,
              hasDelete: false,
              commodity_type: null,
              commodity: null,
              container_type: null,
              quantity: null,
              total_gross_weight: null,
            },
          ],
          paymentTerms: null,
          pickUpContact: { name: null, phone: null },
          deliveryContact: { name: null, phone: null },
          isPickUpInput: null,
          eta: null,
          quotation: null,
          etd: null,
          customs_other_service_type: null,
          has_container_trucking: null,
          isHideShows: false,
          isHideShowPks: false,
          other_pickup_location: null,
          other_delivery_location: null,
          pickup_location: null,
          delivery_location: null,
          other_pickup_region: null,
          other_delivery_region: null,
          pickup_region: null,
          delivery_region: null,
          company_id: null,
          customer_id: null,
          service_type: "5",
          pod_port: null,
          pol_port: null,
          incoterms: null,
          cont_type: null,
          goods_type: null,
          package_type: null,
          transport_type: null,
          deport: null,
          business_type: null,
          so_luong: null,
          trong_luong: null,
          mo_ta: null,
          volume: null,
          from_date: null,
          to_date: null,
          other_service: null,
          notes: null,
          so_khoi: null,
          so_kien: null,
          shipping_line: null,
          place_of_stuffing: null,
          totalChargeWeight: null,
          size_: { length_: null, width_: null, height_: null },
          cargo_ready: "21/09/23 14:32",
          customs_addr: null,
          hs_code: null,
          pickUpDateTime: null,
          pickUpDate: null,
          pickUpTime: null,
          deliveryDateTime: null,
          deliveryDate: null,
          deliveryTime: null,
          cargo_booking: null,
          carrier: null,
          cargo_closing_dateTime: null,
          cargo_closing_date: null,
          cargo_closing_time: null,
          cargo_details_commodity_truck: [
            { id: 1, hasDelete: false, commodity_type: null, commodity: null },
          ],
          cargo_details_container_truck: [
            {
              id: 2,
              hasDelete: false,
              container_type: null,
              quantity: null,
              total_gross_weight: null,
            },
          ],
          additional_custom: false,
          additional_custom_input: null,
          has_other_custom: false,
          place_of_custom: null,
          HS_code_truck: null,
          customs_type: null,
          notes_truck: null,
          door_contact_pick_up: { name: "", phone: "", email: "" },
          door_contact_delivery: { name: "", phone: "", email: "" },
          inland_contact_pick_up: { name: "", phone: "", email: "" },
          inland_contact_delivery: { name: "", phone: "", email: "" },
        };

        this.serviceType = null;
        this.request_quotation.service_type_id = 5;
        this.request_quotation.service_type = 5;

        this.onServiceType(this.request_quotation);
        this.$bvModal.show("modal-create-booking");
        this.isModalChooseService = false;
      } else if (this.chooseServiceType.toString() == "6") {
        this.request_quotation = {
          showAddMore: [
            {
              id: 1,
              hasDelete: false,
              showAddMoreLine: [
                {
                  id: 2,
                  hasDelete: false,
                  gross_weight: null,
                  volume: null,
                  packages: null,
                  dimension: { lenght: null, width: null, height: null },
                },
              ],
              package_type: null,
              total_packages: 0,
              gross_weight_total: 0,
              volume_total: 0,
            },
          ],
          valueVan: [
            {
              id: 1,
              hasDelete: false,
              truck_type: null,
              quantity: null,
              VanLine: [
                {
                  id: 2,
                  hasDelete: false,
                  commodity_type: null,
                  commodity: null,
                  total_gross_weight: null,
                  total_package: null,
                  total_volume: null,
                },
              ],
            },
          ],
          valueContainer: [
            {
              id: 1,
              hasDelete: false,
              commodity_type: null,
              commodity: null,
              container_type: null,
              quantity: null,
              total_gross_weight: null,
            },
          ],
          paymentTerms: null,
          pickUpContact: { name: null, phone: null },
          deliveryContact: { name: null, phone: null },
          isPickUpInput: null,
          eta: null,
          quotation: null,
          etd: null,
          customs_other_service_type: null,
          has_container_trucking: null,
          isHideShows: false,
          isHideShowPks: false,
          other_pickup_location: null,
          other_delivery_location: null,
          pickup_location: null,
          delivery_location: null,
          other_pickup_region: null,
          other_delivery_region: null,
          pickup_region: null,
          delivery_region: null,
          company_id: null,
          customer_id: null,
          service_type: "5",
          pod_port: null,
          pol_port: null,
          incoterms: null,
          cont_type: null,
          goods_type: null,
          package_type: null,
          transport_type: null,
          deport: null,
          business_type: null,
          so_luong: null,
          trong_luong: null,
          mo_ta: null,
          volume: null,
          from_date: null,
          to_date: null,
          other_service: null,
          notes: null,
          so_khoi: null,
          so_kien: null,
          shipping_line: null,
          place_of_stuffing: null,
          totalChargeWeight: null,
          size_: { length_: null, width_: null, height_: null },
          cargo_ready: "21/09/23 14:32",
          customs_addr: null,
          hs_code: null,
          pickUpDateTime: null,
          pickUpDate: null,
          pickUpTime: null,
          deliveryDateTime: null,
          deliveryDate: null,
          deliveryTime: null,
          cargo_booking: null,
          carrier: null,
          cargo_closing_dateTime: null,
          cargo_closing_date: null,
          cargo_closing_time: null,
          cargo_details_commodity_truck: [
            { id: 1, hasDelete: false, commodity_type: null, commodity: null },
          ],
          cargo_details_container_truck: [
            {
              id: 2,
              hasDelete: false,
              container_type: null,
              quantity: null,
              total_gross_weight: null,
            },
          ],
          additional_custom: false,
          additional_custom_input: null,
          has_other_custom: false,
          place_of_custom: null,
          HS_code_truck: null,
          customs_type: null,
          notes_truck: null,
          door_contact_pick_up: { name: "", phone: "", email: "" },
          door_contact_delivery: { name: "", phone: "", email: "" },
          inland_contact_pick_up: { name: "", phone: "", email: "" },
          inland_contact_delivery: { name: "", phone: "", email: "" },
        };

        this.serviceType = null;
        this.request_quotation.service_type_id = 6;
        this.request_quotation.service_type = 6;

        this.onServiceType(this.request_quotation);
        this.$bvModal.show("modal-create-booking");
        this.isModalChooseService = false;
      } else {
        this.request_quotation.service_type_id = this.chooseServiceType;
        this.request_quotation.service_type = type.toString();
        this.request_quotation.company_id = null;
        this.request_quotation.customer_id = null;
        this.onServiceType(this.request_quotation);
        this.$bvModal.show("modal-create-booking");
        this.isModalChooseService = false;
      }
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    loadItem() {
      this.loadBooking(this.menus.filter((i) => i.active)[0].id);
    },

    onHandleView() {
      this.$loading.show();

      this.onRowDoubleClick({ row: this.rowSelectCopy });

      setTimeout(() => {
        this.$loading.hide();
      }, 200);
    },
    async onHandleCopy() {
      this.$store.commit("masterData/SET_TRUCK_LIST", []);
      this.$loading.show();
      this.isCopy = true;
      this.stepNew = "copy-booking";
      this.request_quotation = JSON.parse(
        this.rowSelectCopy.request_quotation_info
      );

      this.request_quotation.booking_note = JSON.parse(
        this.rowSelectCopy.booking_note
      );
      this.request_quotation.quotation = JSON.parse(
        this.rowSelectCopy.booking_info
      );
      this.request_quotation.service_type =
        this.$Utils.CONSTANTS.constantsTypeId[
          this.request_quotation.service_type
        ];
        // Type == LCL @@ :(
      if (this.request_quotation?.service_type?.toString() == "LCL") {
          // check addmore 
        if (!this.request_quotation?.showAddMore){
          this.request_quotation.showAddMore = [
            {
              id: 1,
              hasDelete: false,
              showAddMoreLine: [
                {
                  id: 2,
                  hasDelete: false,
                  gross_weight: null,
                  volume: null,
                  packages: null,
                  dimension: { lenght: null, width: null, height: null },
                },
              ],
              package_type: null,
              total_packages: 0,
              gross_weight_total: 0,
              volume_total: 0,
            },
          ];

        }
      }


      this.serviceType = {
        service_type:
          this.$Utils.CONSTANTS.constantsTypeName[
            this.rowSelectCopy.service_type
          ],
        company_id: this.rowSelectCopy.company_id,
      };

      this.activeTab = 1;
      this.request_quotation.service_type =
        this.$Utils.CONSTANTS.constantsTypeName[
          this.request_quotation.service_type
        ];
      var type = {
        1: "IMPORT",
        2: "EXPORT",
        3: "PORT_TRANSFER",
        4: "ANOTHER_WAREHOUSE",
      };
      // 1 :IMPORT 2: EXPORT 3: PORT_TRANSFER 4: ANOTHER_WAREHOUSE
      this.$store.dispatch(
        "masterData/fetchLocationByUserHandlingTypeLocationTypePickUp",
        {
          customer_id: this.request_quotation.customer_id,
          handling_type_id: type[this.request_quotation.shippingType],
          location_type: "PICK_UP",
          tax_code: this.request_quotation.company_id,
        }
      );
      this.$store.dispatch(
        "masterData/fetchLocationByUserHandlingTypeLocationTypePickUp",
        {
          customer_id: this.request_quotation.customer_id,
          handling_type_id: type[this.request_quotation.shippingType],
          location_type: "DELIVERY",
          tax_code: this.request_quotation.company_id,
        }
      );
      const quotationTemp = JSON.parse(this.rowSelectCopy.booking_info);

      // set trunkId = []
      quotationTemp.costs = quotationTemp.costs.map((cost) => {
        return {
          ...cost,
          detail: cost.detail.map((item) => {
            return {
              ...item,
              truckId: [], // Assign an empty array to truckId for each item
            };
          }),
        };
      });
      setTimeout(() => {
        this.request_quotation.quotation = quotationTemp;
        this.reload++;

        this.$bvModal.show("modal-create-booking");
        const menu = this.$refs.menuRightBooking;
        menu.style.visibility = "hidden";
        this.$loading.hide();
      }, 200);
      // }
    },
    async onClickRightOpenMenu(e, row) {
      // console.log(e);
      // console.log(row);

      e.preventDefault();

      const rs = await GetBookingDetail({
        id: row.id,
      });

      this.rowSelectCopy = row;

      this.rowSelectCopy.request_quotation_info = rs?.request_quotation_info;

      this.rowSelectCopy.booking_note = rs?.booking_note;
      this.rowSelectCopy.booking_info = rs?.booking_info;

      const menu = this.$refs.menuRightBooking,
        menuWidth = menu.offsetWidth,
        menuHeight = menu.offsetHeight,
        card = this.$refs.card;

      let x = e.layerX + 20,
        y = e.layerY + 120,
        winWidth = window.innerWidth,
        winHeight = window.innerHeight;
      //   x = x > winWidth - menuWidth ? winWidth - menuWidth - 5 : x;
      // y = y > winHeight - menuHeight ? winHeight - menuHeight - 5 : y;

      menu.style.left = `${x}px`;
      menu.style.top = `${y}px`;
      menu.style.visibility = "visible";
    },

    loadTotalMyBooking() {
      useJwt
        .get("wr1?objectType=MySaleBooking_count", {
          params: {
            search: {
              ...this.columnKeyword,

              keyword: this.searchTerm,
              to: moment(this.columnFilters.to, "DD/MM/YY").format(
                "YYYY/MM/DD"
              ),
              from: moment(this.columnFilters.from, "DD/MM/YY").format(
                "YYYY/MM/DD"
              ),
            },
          },
        })
        .then((response) => {
          this.totalAllBooking = response.data.result[0];

          this.totalRecords =
            this.totalAllBooking[this.menus.find((i) => i.active).keyTotal];
        });
    },
    containsKey(obj, key) {
      return obj ? hasOwnProperty.call(obj, key) : false;
    },
    async onServiceType(e) {
      if (e.service_type) {
        this.isServiceType = false;
        this.serviceType = e;
        await this.$nextTick();
        // Add my-component from the DOM

        this.isServiceType = true;
      } else {
        this.isServiceType = false;
      }
    },
    formatOption(arr) {
      const mapData = arr.map((obj) => {
        obj.text = obj.text || obj.name;
        obj.id = obj.code;
        return obj;
      });
      return mapData;
    },
    handChooseService() {
      this.rowSelectCopy = null;
      if (this.chooseServiceType == "3") {
        this.request_quotation = {};
        this.stepNew = null;

        this.serviceType = null;
        this.request_quotation.service_type_id = this.chooseServiceType;
        this.request_quotation.service_type_id = "3";
        this.request_quotation.service_type = "3";
        this.onServiceType(this.request_quotation);
        this.valueModal = true;
      } else {
        this.request_quotation.service_type_id = this.chooseServiceType;
        this.request_quotation.service_type = this.chooseServiceType;
        this.request_quotation.company_id = null;
        this.request_quotation.customer_id = null;
        this.onServiceType(this.request_quotation);
        this.$bvModal.show("modal-create-booking");
      }
    },
    async handNewCustomerBookingNoPrice() {
      this.activeTab = 2;
      var validate = await this.$refs.requestQuotationRef.$refs.bcRules
        .validate()
        .then((success) => {
          return success;
        });
      if (!validate) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please enter customer & service!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      validate =
        await this.$refs.requestQuotationRef.$refs.requestQuotationRules
          .validate()
          .then((success) => {
            return success;
          });
      if (!validate) {
        this.activeTab = 1;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the requested information data!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      this.$refs.quotationRef.$data.quotation.accept_files = [];
      this.$refs.requestQuotationRef.$data.request_quotation.files = [];

      let route = this.$router;
      //Lấy các file của request a quotation

      for (
        var i = 0;
        i <
        this.$refs.requestQuotationRef.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()
          .length;
        i++
      ) {
        var file = JSON.parse(
          this.$refs.requestQuotationRef.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[
            i
          ].xhr.response
        ).result;
        file.size =
          this.$refs.requestQuotationRef.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[
            i
          ].size;
        file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
        file.uuid =
          this.$refs.requestQuotationRef.$refs.attachFile.$refs.myVueDropzone.getAcceptedFiles()[
            i
          ].upload.uuid;

        file.fullName = this.userData.fullName;
        file.username = this.userData.username;
        this.$refs.requestQuotationRef.$data.request_quotation.files.push(file);
      }
      let t = 0;

      let totalVatVnd = 0;
      let totalVatUsd = 0;
      let vatVND = 0;
      let vatUSD = 0;
      let totalVND = 0;
      let totalUSD = 0;

      this.$refs.quotationRef.$data.currencies.forEach((e) => {
        t += this.$refs.quotationRef.getTotal(e.id);

        if (e.id == "USD") {
          totalVatUsd += this.$refs.quotationRef.getTotalGrandTotal(e.id);
          vatUSD += this.$refs.quotationRef.getTotalVAT(e.id);
          totalUSD += this.$refs.quotationRef.getTotal(e.id);
        } else {
          totalVatVnd += this.$refs.quotationRef.getTotalGrandTotal(e.id);
          vatVND += this.$refs.quotationRef.getTotalVAT(e.id);
          totalVND += this.$refs.quotationRef.getTotal(e.id);
        }
      });

      const cost_total = {
        exchange_rate: this.exchangeRate,
        total: totalUSD * this.exchangeRate + totalVND,
        vat: vatUSD * this.exchangeRate + vatVND,
        total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
      };

      this.$refs.quotationRef.$data.quotation.costs =
        this.$refs.quotationRef.$data.costs;
      this.$refs.quotationRef.$data.quotation.cost_total = cost_total;
      this.$refs.quotationRef.$data.quotation.commission =
        this.$refs.quotationRef.$data.commission;

      this.$loading.show();


      useJwt
        .post("wr1?objectType=RequestWr1Booking", {
          request_quotation:
            this.$refs.requestQuotationRef.$data.request_quotation,
          quotation: {
            ...this.$refs.quotationRef.$data.quotation,

            createdBy: this.userData.username,
            createDate: moment(new Date()).format("DD/MM/YYYY"),
          },
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("bookingSaleSuccess"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
          this.$emit("sendRequestWr1Booking");
          this.$bvModal.hide("modal-create-booking");
          this.loadBooking(this.menus.filter((i) => i.active)[0].id);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("bookingSaleError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },
    async handNewCustomerBooking(evt) {
      evt.preventDefault();
      this.handCustomerBooking(false);
    },

    async handCheckUpdate() {
      var vm = this;

      if (this.request_quotation.service_type.toString() == "5") {
        var validate =
          await this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.TruckSaleCustomer.$refs.validateCustomer
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          vm.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              //
              title: this.$i18n.t("notifyFormCustomers&service"),
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          await this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.Routing.$refs.validateRouting
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          vm.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check Routing Details field",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          await this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.Cargo.$refs.validateCargoTruck
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          vm.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check Cargo Details field",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          await this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.Billing.$refs.validateBilling
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          vm.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check Billing Information field",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
      }
      if (this.request_quotation.service_type.toString() == "6") {
        var validate =
          await this.$refs.requestQuotationRef.$refs.NewVanTruckSale.$refs.NewVanTruckSale.$refs.TruckSaleCustomer.$refs.validateCustomer
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          this.$toast({
            component: ToastificationContent,
            props: {
              //
              title: this.$i18n.t("notifyFormCustomers&service"),
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          await this.$refs.requestQuotationRef.$refs.NewVanTruckSale.$refs.NewVanTruckSale.$refs.Routing.$refs.validateRouting
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          vm.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check Routing Details field",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          await this.$refs.requestQuotationRef.$refs.NewVanTruckSale.$refs.NewVanTruckSale.$refs.Cargo.$refs.validateCargoTruck
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          vm.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check Cargo Details field",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
      }
      if (this.request_quotation.service_type.toString() == "3") {
        var validate =
          // await  this.$refs.requestQuotationRef.$refs.bcRules
          await this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.LCLBookingSaleCustomer.$refs.validateCustomer
            .validate()
            .then((success) => {
              return success;
            });

        if (!validate) {
          vm.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please enter customer & service!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }

        validate =
          // await this.$refs.requestQuotationRef.$refs.requestQuotationRules
          await this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.Routing.$refs.validateRouting
            .validate()
            .then((success) => {
              return success;
            });

        if (!validate) {
          vm.activeTab = 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Routing Details data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          // await this.$refs.requestQuotationRef.$refs.requestQuotationRules
          await this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.Sailing.$refs.validateSailing
            .validate()
            .then((success) => {
              return success;
            });

        if (!validate) {
          vm.activeTab = 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Sailing Schedule data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          // await this.$refs.requestQuotationRef.$refs.requestQuotationRules
          await this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.Cargo.$refs.validateCargo
            .validate()
            .then((success) => {
              return success;
            });

        if (!validate) {
          vm.activeTab = 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Cargo Detail data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        if (
          !this.$refs.requestQuotationRef.$data.request_quotation.collect &&
          !this.$refs.requestQuotationRef.$data.request_quotation.prepaid
        ) {
          vm.activeTab = 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Freight Term data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        if (
          !this.$refs.requestQuotationRef.$data.request_quotation.stack_able &&
          !this.$refs.requestQuotationRef.$data.request_quotation
            .non_stack_able &&
          !this.$refs.requestQuotationRef.$data.request_quotation.rotatable
        ) {
          vm.activeTab = 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Sailing Schedule data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
      }
    },

    async handCustomerBooking(edit) {
      if (this.request_quotation.service_type.toString() == "5") {
        var validate =
          await this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.TruckSaleCustomer.$refs.validateCustomer
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          this.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              //
              title: this.$i18n.t("notifyFormCustomers&service"),
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          await this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.Routing.$refs.validateRouting
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          this.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check Routing Details field",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          await this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.Cargo.$refs.validateCargoTruck
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          this.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check Cargo Details field",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          await this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.Billing.$refs.validateBilling
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          this.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check Billing Information field",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
      }
      if (this.request_quotation.service_type.toString() == "6") {
        var validate =
          await this.$refs.requestQuotationRef.$refs.NewVanTruckSale.$refs.NewVanTruckSale.$refs.TruckSaleCustomer.$refs.validateCustomer
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          this.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              //
              title: this.$i18n.t("notifyFormCustomers&service"),
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          await this.$refs.requestQuotationRef.$refs.NewVanTruckSale.$refs.NewVanTruckSale.$refs.Routing.$refs.validateRouting
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          this.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check Routing Details field",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          await this.$refs.requestQuotationRef.$refs.NewVanTruckSale.$refs.NewVanTruckSale.$refs.Cargo.$refs.validateCargoTruck
            .validate()
            .then((success) => {
              return success;
            });
        if (!validate) {
          this.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check Cargo Details field",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
      }
      if (this.request_quotation.service_type.toString() == "3") {
          // check 



        var validate =
          // await  this.$refs.requestQuotationRef.$refs.bcRules
          await this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.LCLBookingSaleCustomer.$refs.validateCustomer
            .validate()
            .then((success) => {
              return success;
            });

        if (!validate) {
          this.activeTab = 1;

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please enter customer & service!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }

        validate =
          // await this.$refs.requestQuotationRef.$refs.requestQuotationRules
          await this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.Routing.$refs.validateRouting
            .validate()
            .then((success) => {
              return success;
            });

        if (!validate) {
          this.activeTab = 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Routing Details data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        validate =
          // await this.$refs.requestQuotationRef.$refs.requestQuotationRules
          await this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.Sailing.$refs.validateSailing
            .validate()
            .then((success) => {
              return success;
            });

        if (!validate) {
          this.activeTab = 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Sailing Schedule data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }




        validate =
          // await this.$refs.requestQuotationRef.$refs.requestQuotationRules
          await this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.Cargo.$refs.validateCargo
            .validate()
            .then((success) => {
              return success;
            });

        if (!validate) {
          this.activeTab = 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Cargo Detail data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }

        if (
          !this.$refs.requestQuotationRef?.$data.request_quotation?.showAddMore
        ) {
      
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Cargo Detail data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }

        if (
          !this.$refs.requestQuotationRef.$data.request_quotation.collect &&
          !this.$refs.requestQuotationRef.$data.request_quotation.prepaid
        ) {
          this.activeTab = 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Freight Term data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        if (
          !this.$refs.requestQuotationRef.$data.request_quotation.stack_able &&
          !this.$refs.requestQuotationRef.$data.request_quotation
            .non_stack_able &&
          !this.$refs.requestQuotationRef.$data.request_quotation.rotatable
        ) {
          this.activeTab = 1;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Please check the requested Sailing Schedule data!",
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
      }

      this.request_quotation =
        this.$refs.requestQuotationRef.$data.request_quotation;
      if (this.request_quotation.quotation && this.isCopy == false) {
        const temp =
          this.quotations.find((e) => e.id == this.request_quotation.quotation)
            ?.quotation_info || {};
        this.quotation = JSON.parse(temp);
        this.reload++;
      } else if (this.request_quotation.quotation && this.isCopy == true) {
        if (typeof this.request_quotation.quotation == "object") {
          this.quotation = this.request_quotation.quotation;
          this.reloadQua++;
        } else {
          const temp =
            this.quotations.find(
              (e) => e.id == this.request_quotation.quotation
            )?.quotation_info || {};
          this.quotation = JSON.parse(temp);
          this.reloadQua++;
        }
      }

      this.$refs.quotationRef.$data.quotation.accept_files = [];
      this.$refs.requestQuotationRef.$data.request_quotation.files = [];

      let route = this.$router;
      //Lấy các file của request a quotation

      if (this.request_quotation.service_type.toString() == "5") {
        for (
          var i = 0;
          i <
          this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()
            .length;
          i++
        ) {
          var file = JSON.parse(
            this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
              i
            ].xhr.response
          ).result;
          file.size =
            this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
              i
            ].size;
          file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
          file.uuid =
            this.$refs.requestQuotationRef.$refs.ContainerTruckSale.$refs.ContainerTruckSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
              i
            ].upload.uuid;

          file.fullName = this.userData.fullName;
          file.username = this.userData.username;
          this.$refs.requestQuotationRef.$data.request_quotation.files.push(
            file
          );
        }
      }
      if (this.request_quotation.service_type.toString() == "6") {
        for (
          var i = 0;
          i <
          this.$refs.requestQuotationRef.$refs.NewVanTruckSale.$refs.NewVanTruckSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()
            .length;
          i++
        ) {
          var file = JSON.parse(
            this.$refs.requestQuotationRef.$refs.NewVanTruckSale.$refs.NewVanTruckSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
              i
            ].xhr.response
          ).result;
          file.size =
            this.$refs.requestQuotationRef.$refs.NewVanTruckSale.$refs.NewVanTruckSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
              i
            ].size;
          file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
          file.uuid =
            this.$refs.requestQuotationRef.$refs.NewVanTruckSale.$refs.NewVanTruckSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
              i
            ].upload.uuid;

          file.fullName = this.userData.fullName;
          file.username = this.userData.username;
          this.$refs.requestQuotationRef.$data.request_quotation.files.push(
            file
          );
        }
      }
      if (this.request_quotation.service_type.toString() == "3") {
        for (
          var i = 0;
          i <
          this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()
            .length;
          i++
        ) {
          var file = JSON.parse(
            this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
              i
            ].xhr.response
          ).result;
          file.size =
            this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
              i
            ].size;
          file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
          file.uuid =
            this.$refs.requestQuotationRef.$refs.NewBookingSale.$refs.LCLBookingSale.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
              i
            ].upload.uuid;

          file.fullName = this.userData.fullName;
          file.username = this.userData.username;
          this.$refs.requestQuotationRef.$data.request_quotation.files.push(
            file
          );
        }
      }
      if (this.activeTab === 1) {
        this.activeTab = 2;
        this.reloadQua++;

        return;
      }
      let t = 0;
      let totalVatVnd = 0;
      let totalVatUsd = 0;
      let vatVND = 0;
      let vatUSD = 0;
      let totalVND = 0;
      let totalUSD = 0;

      this.$refs.quotationRef.$data.currencies.forEach((e) => {
        t += this.$refs.quotationRef.getTotal(e.id);

        if (e.id == "USD") {
          totalVatUsd += this.$refs.quotationRef.getTotalGrandTotal(e.id);
          vatUSD += this.$refs.quotationRef.getTotalVAT(e.id);
          totalUSD += this.$refs.quotationRef.getTotal(e.id);
        } else {
          totalVatVnd += this.$refs.quotationRef.getTotalGrandTotal(e.id);
          vatVND += this.$refs.quotationRef.getTotalVAT(e.id);
          totalVND += this.$refs.quotationRef.getTotal(e.id);
        }
      });
      const cost_total = {
        exchange_rate: this.exchangeRate,
        total: totalUSD * this.exchangeRate + totalVND,
        vat: vatUSD * this.exchangeRate + vatVND,
        total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
      };
      // if (t == 0 || Number.isNaN(t)) {
      //   this.activeTab = 2;

      //   this.$toast({
      //     component: ToastificationContent,
      //     props: {
      //       title: "Total = 0, please enter at least one fee!",
      //       icon: "AlertTriangleIcon",
      //       variant: "warning",
      //     },
      //   });
      //   return;
      // }
      this.$refs.quotationRef.$data.quotation.costs =
        this.$refs.quotationRef.$data.costs;
      this.$refs.quotationRef.$data.quotation.cost_total = cost_total;
      this.$refs.quotationRef.$data.quotation.commission =
        this.$refs.quotationRef.$data.commission;

      if (edit) {
        this.$loading.show();

        useJwt
          .put("wr1?objectType=RequestWr1Booking", {
            request_quotation:
              this.$refs.requestQuotationRef.$data.request_quotation,
            quotation: {
              ...this.$refs.quotationRef.$data.quotation,
              createdBy: this.userData.username,
              createDate: moment(new Date()).format("DD/MM/YYYY"),
            },
          })
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("quotationUpdateSuccess"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$emit("sendRequestWr1Booking");
            this.$bvModal.hide(
              edit ? "modal-edit-booking" : "modal-create-booking"
            );
            this.loadBooking(this.menus.filter((i) => i.active)[0].id);
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("notifyRequestingUpdateQuoteError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      } else {
        this.$loading.show();

        useJwt
          .post("wr1?objectType=RequestWr1Booking", {
            request_quotation:
              this.$refs.requestQuotationRef.$data.request_quotation,
            quotation: {
              ...this.$refs.quotationRef.$data.quotation,
              createdBy: this.userData.username,
              createDate: moment(new Date()).format("DD/MM/YYYY"),
            },
          })
          .then((response) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("bookingSaleSuccess"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            this.$emit("bookingSaleSuccess");
            this.$bvModal.hide(
              edit ? "modal-edit-booking" : "modal-create-booking"
            );
            this.loadBooking(this.menus.filter((i) => i.active)[0].id);
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("bookingSaleError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      }
    },

    async loadBooking(status) {
      this.$loading.show();
      this.menus.filter((i) => i).forEach((e) => (e.active = false));

      const dataActive = this.menus.find((i) => i.id == status);

      dataActive.active = true;
      // console.log(dataActive);

      this.getData(dataActive.id, dataActive.variable);
      // await this.menus.map((i) => this.getData(i.id, i.variable));
    },
    onPageChange(params) {
      this.$loading.show();

      this.page = params;
      this.loadBooking(this.menus.filter((i) => i.active)[0].id);
    },
    onPerPageChange(params) {
      this.$loading.show();

      this.pageSize = params;
      this.page = 1;
      this.loadBooking(this.menus.filter((i) => i.active)[0].id);
      this.$refs["my-table"].reset();
    },
    onColumnFilter(params) {
      const { columnFilters } = params;
      console.log(columnFilters);
      this.columnKeyword = {
        ...columnFilters,
        status_name: columnFilters.status,
      };
      delete this.columnKeyword.status;
    },

    getData(status, name) {
      this.$loading.show();
      this.stepNew = null;
      this.loadTotalMyBooking();

      useJwt
        .get("wr1?objectType=MySaleBooking", {
          params: {
            search: {
              status: status,
              keyword: this.searchTerm,
              ...this.columnKeyword,
              to: moment(this.columnFilters.to, "DD/MM/YY").format(
                "YYYY/MM/DD"
              ),
              from: moment(this.columnFilters.from, "DD/MM/YY").format(
                "YYYY/MM/DD"
              ),
            },
            page: this.page,
            pageSize: this.pageSize,
          },
        })
        .then((response) => {
          const mapData = response.data.result.map((obj) => {
            obj.etd = checkDateToFormat(obj.etd);
            obj.eta = checkDateToFormat(obj.eta);
            obj.cargo_ready = checkDateTimeToFormat(obj.cargo_ready);
            obj.pick_up_date = checkDateTimeToFormat(obj.pick_up_date);

            obj.delivery_date = checkDateTimeToFormat(obj.delivery_date);

            if (obj?.shipment_info != "" && obj?.shipment_info != null) {
              JSON.parse(obj.shipment_info).forEach((k) => {
                if (k.id == "4.1") {
                  obj.HBL = k.hbl;
                }
              });
            }

            return obj;
          });
          this.rows[name] = mapData;
          if (
            this.objectType == "BOOKING_REQUEST_AN_UPDATE" &&
            this.searchTerm
          ) {
            this.onRowDoubleClick({ row: this.rows[name][0] });
            this.$store.commit("tabView/SET_OBJECT_TYPE", null);
            this.$store.commit("tabView/SET_OBJECT_VIEW", true);
          }
          // this.$refs["my-table"].reset();
        })
        .finally(() => {
          this.$loading.hide();
          // this.$refs["my-table"].reset();
        });
    },

    async handConfirmIncurredCost(ev) {
      ev.preventDefault();
      this.booking.incurredCost = this.incurredCost;
      this.booking.createdByCost = this.userData.username;
      this.booking.createDateCost = moment(new Date()).format("DD/MM/YYYY");
      const validate = await this.$refs.reqCostRules

        .validate()
        .then((success) => {
          return success;
        });

      if (!validate) {
        // notifyFormQuoteError

        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("notifyFormError"),
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      this.$loading.show();

      useJwt
        .put("wr1?objectType=UpdateBookingInfo", this.booking)
        .then((response) => {
          if (response.data.result == 1) {
            this.$bvModal.hide("modal-confirm-incurred-cost");
            this.loadBooking(this.menus.filter((i) => i.active)[0].id);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Resend Booking success!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message,
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          }
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Resend Booking success error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => this.$loading.hide());
    },

    async handleRejectBooking() {
      if (this.rejectReason == "" || this.rejectReason == null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check data input reject",
            icon: "CheckSquareIcon",
            variant: "danger",
          },
        });
      } else {
        useJwt
          .put("wr1?objectType=Reject", {
            id: this.request_quotation.id,
            reject_reason: this.rejectReason,
          })
          .then((response) => {
            this.$bvModal.hide("modal-confirm-booking");
            this.loadBooking(this.menus.filter((i) => i.active)[0].id);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: "You declined this quote",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })

          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("notifyRequestingUpdateQuoteError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.ModalReject = false;
            this.$loading.hide();
          });
      }
    },
    async handConfirmBooking(ev) {
      ev.preventDefault();
      if (this.booking == null) {
        if (
          this.request_quotation.quotation &&
          this.stepTab == 0 &&
          typeof this.request_quotation.quotation == "string"
        ) {
          const temp =
            this.quotations.find(
              (e) => e.id == this.request_quotation.quotation
            ).quotation_info || {};
          this.quotation = JSON.parse(temp);
          this.reloadQua++;
        }
        if (this.stepTab == 0) {
          this.stepTab = 2;
          this.activeTab = 2;
          return;
        }
        this.quotation = this.$refs.quotationRef.$data.quotation;
        // if (this.stepTab < 1 && this.request_quotation.service_type != "LCL") {
        //   this.stepTab = 3;
        //   this.activeTab = 2;
        //   return;
        // }
        // if (
        //   this.stepTab == 1 &&
        //   (this.request_quotation.service_type == "LCL" ||
        //     this.request_quotation.service_type == "3")
        // ) {
        //   this.postBookingNote();
        //   this.activeTab = 2;
        //   this.stepTab = 2;
        //   return;
        // }

        let t = 0;
        let totalVatVnd = 0;
        let totalVatUsd = 0;
        let vatVND = 0;
        let vatUSD = 0;
        let totalVND = 0;
        let totalUSD = 0;

        this.$refs.quotationRef.$data.currencies.forEach((e) => {
          t += this.$refs.quotationRef.getTotal(e.id);

          if (e.id == "USD") {
            totalVatUsd += this.$refs.quotationRef.getTotalGrandTotal(e.id);
            vatUSD += this.$refs.quotationRef.getTotalVAT(e.id);
            totalUSD += this.$refs.quotationRef.getTotal(e.id);
          } else {
            totalVatVnd += this.$refs.quotationRef.getTotalGrandTotal(e.id);
            vatVND += this.$refs.quotationRef.getTotalVAT(e.id);
            totalVND += this.$refs.quotationRef.getTotal(e.id);
          }
        });

        const cost_total = {
          exchange_rate: this.exchangeRate,
          total: totalUSD * this.exchangeRate + totalVND,
          vat: vatUSD * this.exchangeRate + vatVND,
          total_vat: totalVatUsd * this.exchangeRate + totalVatVnd,
        };

        this.$refs.quotationRef.$data.quotation.costs =
          this.$refs.quotationRef.$data.costs;

        this.$refs.quotationRef.$data.quotation.costs =
          this.$refs.quotationRef.$data.costs;

        this.$refs.quotationRef.$data.quotation.commission =
          this.$refs.quotationRef.$data.commission;

        this.$refs.quotationRef.$data.quotation.cost_total = cost_total;

        const validate = await this.$refs.quotationRef.$refs.quotationRules

          .validate()
          .then((success) => {
            return success;
          });

        if (!validate) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("notifyFormQuoteError"),
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        // if (t == 0 || Number.isNaN(t)) {
        //   this.$toast({
        //     component: ToastificationContent,
        //     props: {
        //       title: "Total = 0, please enter at least one fee!",
        //       icon: "AlertTriangleIcon",
        //       variant: "warning",
        //     },
        //   });
        //   return;
        // }
        this.$loading.show();
        useJwt
          .put("wr1?objectType=RequestWr1Booking", {
            request_quotation: this.request_quotation,
            quotation: {
              ...this.$refs.quotationRef.$data.quotation,
              createdBy: this.userData.username,
              createDate: moment(new Date()).format("DD/MM/YYYY"),
            },
          })
          .then((response) => {
            this.$bvModal.hide("modal-confirm-booking");
            this.loadBooking(this.menus.filter((i) => i.active)[0].id);

            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("quotationUpdateSuccess"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })

          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("notifyRequestingUpdateQuoteError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      } else {
        this.$loading.show();

        useJwt
          .put("wr1?objectType=ConfirmBooking", {
            id: this.request_quotation.id,
            booking_sale_id: this.booking.booking_sale_id,
          })
          .then((response) => {
            this.$bvModal.hide("modal-confirm-booking");
            this.loadBooking(this.menus.filter((i) => i.active)[0].id);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Booking confirmed!",
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Booking confirm error",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => this.$loading.hide());
      }
    },

    confirmOut() {
      this.$refs.Booking.hide();
    },
    hideModalAll(event) {
      this.isCopy = false;
      if (
        this.$refs.ViewAllBooking.$refs.CreateQuotation.$data.showUpdate &&
        this.valueConfirmOut == false &&
        this.$refs.ViewAllBooking.$refs.CreateQuotation.$data.hasChange
      ) {
        this.valueConfirmOut = true;
        event.preventDefault();
      } else {
        const menu = this.menus.filter((i) => i.active)[0];
        this.getData(menu.id, menu.variable);
      }
    },
    async showViewAll(modal_id, row, activeTab, enableEditBooking, payload) {
      let details = payload || null;
      if (
        row.status_id.toString() ===
          this.$Utils.BOOKING_NAME.BOOKING_SUBMITTED.toString() &&
        (this.userData.userType ==
          this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
          this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin)
      ) {
        UpdateStatusBooking(row.id);
        row.status_id = this.$Utils.BOOKING_NAME.RECEIVED_BOOKING_REQUEST;
      }

      if (!details) {
        try {
          const rs = await GetBookingDetail({
            id: row.id,
          });
          details = rs;
        } catch (error) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Server error!",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      }
      // console.log(row);

      this.incurredCost = "";
      this.request_quotation = null;
      this.quotation = null;
      this.booking = null;

      // this.costs_info = null;

      // search.bookingStatus
      // search.serviceTypeId
      // search.pickupAddrId
      // search.deliveryAddrId
      // search.contType
      // search.taxCode

      this.activeTab = activeTab;

      this.enableEditBooking = enableEditBooking;
      //TODO track trace

      this.shipment = JSON.parse(details?.shipment_info_all);

      this.shipment_on_fast = JSON.parse(details?.shipment_on_fast_info);
      if (details?.shipment_on_tms_info != null) {
        this.shipment_on_tms = JSON.parse(details?.shipment_on_tms_info);
      }

      this.request_quotation = JSON.parse(details?.request_quotation_info);

      if (this.shipment && this.request_quotation) {
        this.shipment.forEach((k) => {
          if (k.id == "4.1") {
            this.request_quotation.HBL = k.hbl || "";
          }
        });
      }

      this.request_quotation.id = row.id;
      this.request_quotation.status_id = row.status_id;
      this.request_quotation.customer_id = details?.customer_id;
      this.request_quotation.sale_id = details?.sale_id;
      this.request_quotation.sale_name = details?.sale_name;
      this.request_quotation.customer_name = details?.customer_name;
      this.request_quotation.customer_phone = details?.customer_phone;
      this.request_quotation.customer_email = details?.customer_email;
      this.request_quotation.customer_company_name =
        details?.customer_company_name;
      this.request_quotation.cancel_reason = details?.cancel_reason;
      this.request_quotation.company_id = details?.company_id;

      this.request_quotation.files_new = JSON.parse(details?.files);
      this.request_quotation.accept_files_new = JSON.parse(
        details?.accept_files
      );

      this.loadTrackTrace();

      if (details?.quotation_info != null && details?.quotation_info != "") {
        this.quotation = JSON.parse(details?.quotation_info);
        this.quotation.id = row.id;
        this.quotation.status_id = row.status_id;
        this.request_quotation.shipping_line = this.quotation.shipping_line;

        this.request_quotation.cut_off_time = this.quotation.cut_off;
      }
      if (details?.booking_info != null && details?.booking_info != "") {
        this.booking = JSON.parse(details?.booking_info);
        this.booking.id = row.id;
        this.booking.status_id = row.status_id;
        this.booking.booking_sale_id = details?.sale_id;
        this.incurredCost = this.booking.incurredCost;
      }

      if (
        (row.service_type == "Van Trucking" &&
          this.request_quotation.pickup_location != null &&
          this.request_quotation.delivery_location != null) ||
        (row.service_type == "Container Trucking" &&
          this.request_quotation.pickup_location != null &&
          this.request_quotation.delivery_location != null)
      ) {
        const rs = await GetLastBookingOfVanCont({
          bookingStatus: this.$Utils.CONSTANTS.STATUS_WR1.APPROVED,
          serviceTypeId: this.request_quotation.service_type,
          pickupAddrId: this.request_quotation.pickup_location,
          deliveryAddrId: this.request_quotation.delivery_location,
          contType: this.request_quotation.cont_type,
          taxCode: details?.company_id,
        });
        if (rs.length > 0)
          this.request_quotation.costs_van_cont = JSON.parse(
            rs[0].quotation_info
          );
      }
      if (
        (row.status_id.toString() ==
          this.$Utils.BOOKING_NAME.RECEIVED_BOOKING_REQUEST.toString() &&
          this.userData.userType ==
            this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale) ||
        (row.status_id.toString() ==
          this.$Utils.BOOKING_NAME.RECEIVED_BOOKING_REQUEST.toString() &&
          this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin)
      ) {
        this.booking_note = {
          showAddMore: [
            {
              id: 1,
              hasDelete: false,
              showAddMoreLine: [
                {
                  id: 2,
                  hasDelete: false,
                  gross_weight: null,
                  volume: null,
                  packages: null,
                  dimension: {
                    lenght: null,
                    width: null,
                    height: null,
                  },
                },
              ],
              package_type: null,
              total_packages: 0,
              gross_weight_total: 0,
              volume_total: 0,
            },
          ],
          status_id: row.status_id,
          shipping_line: this.request_quotation.shipping_line,
          company_id: details?.company_id,
          company_name: details?.customer_company_name,
          customer_name: details?.customer_name,
          sale_name: details?.sale_name,
          vessel_name: this.request_quotation.vessel_name,
          pol_name: this.request_quotation.pol_name,
          pod_name: this.request_quotation.pod_name,
          placeOfDelivery_name: null,
          goods_type_name: this.request_quotation.goods_type_name,
          service_type: "3",
          customer_id: details?.customer_id,
          customer_email: details?.customer_email,
          sale_id: details?.sale_id,
          booking_date: moment().format("DD/MM/YY HH:mm"),
          booking_no: row.id,
          place_of_stuffing: this.request_quotation.place_of_stuffing,
          contact: this.request_quotation.contact,
          closing_time: this.request_quotation.closing_time,
          cut_si_vgm: this.request_quotation.cut_si_vgm,
          pol_port: this.request_quotation.pol_port,
          pod_port: this.request_quotation.pod_port,
          placeOfDelivery: null,
          eta: row.eta,
          etd: row.etd,
          goods_type: this.request_quotation.goods_type,
          packageNumber: this.request_quotation.packageNumber,
          trong_luong: this.request_quotation.trong_luong,
          so_khoi: this.request_quotation.so_khoi,
          note: `1. Please contact our operation 2 hours before loading cargo to stuffing place.
    2. Please bring a booking note, declaration, barcode, vgm.
    3. Wooden packages & wooden products must be fumigated at shipper's premise.
    4. Shipping mark on the surface of all crate/carton/case is shipper's responsibility to attach.
    5. Our services such as warehouse, trucking, trailer, and customs clearance, are always available to provide by our own facility. Please keep in contact for any requirements.
    6. The cargo which is classified as dangerous, foodstuff, personal effects, over 580 cm length/pkg, over 500kgs/pkg, or required special treatments which are limited for sea transportation have to be informed to WR1 before booking.
    7. For European trade lane: HS code of cargo required to provide at least two days before ETD.
    8. For US/Canada trade lanes: No personal effects are accepted.
    9. If the consignee refuses to collect cargo and pay destination charges, all arising expenses and destination charges due to abandoning and/or destroying cargo will be debited to the shipper's account.

    In case you and/or your relevant parties fail to declare the mentioned request with WR1, all extra arising charges will be debited to your account.`,
        };
      }
      this.$bvModal.show(modal_id);
    },

    updateBookingStatus(node) {
      this.isOnBoard = false;
      this.current_shipment_status.date_ =
        moment().format("DD-MM-YYYY HH:m:ss");
      this.$bvModal.show("modal-update-status-confirm");
      this.current_shipment_status.id = node.data.id;
      this.current_shipment_status.index = node.data.index;

      // if (this.isCheckStatus && this.isCheckStatus.length != 0) {
      //   this.isOnBoard = false;
      // } else {
      //   if (node.data.id >= "4.1") {
      //     if (node.data.id == "4.1") {
      //       this.isOnBoard = true;
      //     } else if (node.data.id !== "7.2") {
      //       let status = this.track_trace_status.filter(
      //         (e) => e.text == "On Board"
      //       );
      //       if (status.length > 0) {
      //         this.isOnBoard = false;
      //         this.isOnBoard = status[0].children[0]?.selected;
      //       }
      //       this.current_shipment_status.HBL =
      //         this.track_trace_status.filter((e) => e.text == "On Board")[0]
      //           ?.children[0]?.HBL || "";
      //       if (this.current_shipment_status.HBL != "") this.isOnBoard = false;
      //     }
      //   } else {
      //     this.isOnBoard = false;
      //   }
      // }

      this.current_shipment_status.selected = node.data.selected;
    },
    handUpdateBookingStatus(ev) {
      ev.preventDefault();
      //Xoá hết các item cũ
      let shipment_ = JSON.parse(JSON.stringify(this.shipment));

      //Nếu check là hoàn thành thì thêm
      let temp_shipment_ = [];
      let check = true;

      this.track_trace_status.forEach((e) => {
        e.children.forEach((e) => {
          if (
            check &&
            ((e.selected && e.index <= this.current_shipment_status.index) ||
              (!e.selected && e.index < this.current_shipment_status.index))
          ) {
            if (e.id == "4.1") {
              let x = {
                id: e.id,
                hbl: this.current_shipment_status.HBL,
                date_: e.date_ || this.current_shipment_status.date_,
                driver_name: e.driver_name,
                driver_phone: e.driver_phone,
                driver_card_id: e.driver_card_id,
                truck_plate: e.truck_plate,
                cont_no: e.cont_no,
                seal_no: e.seal_no,
              };
              temp_shipment_.push(x);
            } else {
              let x = {
                id: e.id,
                date_: e.date_ || this.current_shipment_status.date_,
                driver_name: e.driver_name,
                driver_phone: e.driver_phone,
                driver_card_id: e.driver_card_id,
                truck_plate: e.truck_plate,
                cont_no: e.cont_no,
                seal_no: e.seal_no,
              };
              temp_shipment_.push(x);

              return;
            }
          }
        });
      }, this);

      this.$loading.show();

      var listStatus = this.lists.filter(
        (i) => temp_shipment_[temp_shipment_.length - 1].id == i.id
      );
      var payload = {
        id: this.booking.id,
        shipment: temp_shipment_,
        sub_status: temp_shipment_[temp_shipment_.length - 1].id,
        status: listStatus[0].idStatus.toString(),
      };

      useJwt
        .put("wr1?objectType=UpdateBookingStatus", payload)
        .then((response) => {
          this.$bvModal.hide("modal-update-status-confirm");
          this.$bvModal.hide("modal-update-status");
          this.$bvModal.hide("this.isCheckStatus");
          this.loadBooking(this.menus.filter((i) => i.active)[0].id);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Update Booking Status Success!",
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Update Booking Status Success error",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.$loading.hide();
          this.isCheckStatus = [];
        });
    },
    handCancelUpdateBookingStatus(ev) {
      this.loadTrackTrace();
    },
    vdropzoneError(file, errorMessage) {
      this.$refs.acceptBookingFile.removeFile(file);
      if (errorMessage.includes("Max filesize: 10MiB")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadSizeErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }

      if (errorMessage.includes("You can not upload any more files.")) {
        return this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$i18n.t("uploadLimitErrorFile"),
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
  },
  beforeDestroy() {
    this.$store.commit("tabView/SET_OBJECT_ID", null);
    this.$store.commit(
      "tabView/SET_TAB_BOOKING",
      "61,5,17,16,6,63,62,7,31,37,38,39,40,41,42,43,44,36,35,34,25,26,27,28,29,30,32,33,8,11,9,13,10,12"
    );
  },
};
</script>
<style>
/* .nav-link {
  color: #6e6b7b;
}

.nav-item .active {
  color: #2b938c;
  font-weight: bold;
  border-bottom: 3px solid #2b938c;
} */

.select2-selection--single {
  border: 1px solid #2b938c;
  border-radius: 1.5rem;
}

.select2-selection--single:before {
  content: "";
  position: absolute;
  right: 14px;
  top: 0;
  bottom: 0;
  width: 14px;
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNiIgdmlld0JveD0iMCAwIDEwIDYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xIDFMNSA1TDkgMSIgc3Ryb2tlPSIjMkI5MzhDIiBzdHJva2Utd2lkdGg9IjEuMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=")
    center / contain no-repeat;
}

.select2-selection__arrow {
  background: none;
  display: none !important;
}

.vgt-table1 {
  min-width: 130vw;
}

.vgt-table td,
.vgt-table th {
  vertical-align: middle !important;
  font-size: 1rem;
}

.vgt-table th {
  text-align: center;
}

.step-t1 {
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjA3NTggMC41ODU1ODRDMTUuMDY3OSAwLjQyNzYxIDE0Ljk5OTYgMC4yNzg3MjIgMTQuODg1IDAuMTY5NzI0QzE0Ljc3MDUgMC4wNjA3MjU3IDE0LjYxODQgLTMuOTY0N2UtMDUgMTQuNDYwMyAxLjk0MDc4ZS0wOEgxMi43MDVDMTIuNTUxMiAtOC45NDE4OGUtMDYgMTIuNDAyOSAwLjA1NzU0MDcgMTIuMjg5NCAwLjE2MTMzN0MxMi4xNzU4IDAuMjY1MTM0IDEyLjEwNTIgMC40MDc2NjkgMTIuMDkxMyAwLjU2MDkyOEwxMS4wOTAxIDExLjg1MDRWNy4zNzAzNEg5Ljg1NzkxVjUuNTIxMTNDOS44NTc0NCA1LjQwOTggOS44MjY5IDUuMzAwNjcgOS43Njk1MiA1LjIwNTI4QzkuNzEyMTQgNS4xMDk4OCA5LjYzMDA2IDUuMDMxNzggOS41MzE5NSA0Ljk3OTIzQzkuNDMzODUgNC45MjY2OSA5LjMyMzM3IDQuOTAxNjQgOS4yMTIyMSA0LjkwNjc2QzkuMTAxMDQgNC45MTE4NyA4Ljk5MzMzIDQuOTQ2OTUgOC45MDA0NiA1LjAwODI4TDUuMzU4MzkgNy4zNzAzNEg0LjkyODk1VjUuNTIxMTNDNC45Mjg0OCA1LjQwOTggNC44OTc5NCA1LjMwMDY3IDQuODQwNTYgNS4yMDUyOEM0Ljc4MzE5IDUuMTA5ODggNC43MDExIDUuMDMxNzggNC42MDMgNC45NzkyM0M0LjUwNDg5IDQuOTI2NjkgNC4zOTQ0MiA0LjkwMTY0IDQuMjgzMjUgNC45MDY3NkM0LjE3MjA5IDQuOTExODcgNC4wNjQzOCA0Ljk0Njk1IDMuOTcxNSA1LjAwODI4TDAuMjc0Nzg5IDcuNDczOUMwLjE5MDMxOCA3LjUzMDE0IDAuMTIxMDM4IDcuNjA2MzcgMC4wNzMxIDcuNjk1ODRDMC4wMjUxNjI1IDcuNzg1MzEgNS4yNDMyMmUtMDUgNy44ODUyNCAwIDcuOTg2NzVMMCAxNS4zODM2QzAgMTUuNTQ3MSAwLjA2NDkxMjQgMTUuNzAzOSAwLjE4MDQ1NyAxNS44MTk1QzAuMjk2MDAyIDE1LjkzNTEgMC40NTI3MTQgMTYgMC42MTYxMTkgMTZIMTUuNDE1M0MxNS43NTYgMTYgMTYgMTUuNzgzIDE2IDE1LjQ0MjhDMTYgMTUuMzg5OCAxNS4wNzU4IDAuNTg1NTg0IDE1LjA3NTggMC41ODU1ODRWMC41ODU1ODRaTTMuMDgwNiA4LjYwMzE1VjEwLjQ1MjRIMS44NDgzNlY4LjYwMzE1SDMuMDgwNlpNNi4xNjExOSA4LjYwMzE1VjEwLjQ1MjRINC45Mjg5NVY4LjYwMzE1SDYuMTYxMTlaTTkuMjQxNzkgOC42MDMxNVYxMC40NTI0SDguMDA5NTVWOC42MDMxNUg5LjI0MTc5Wk0zLjA4MDYgMTEuNjg1MlYxMy41MzQ0SDEuODQ4MzZWMTEuNjg1MkgzLjA4MDZaTTYuMTYxMTkgMTEuNjg1MlYxMy41MzQ0SDQuOTI4OTVWMTEuNjg1Mkg2LjE2MTE5Wk05LjI0MTc5IDExLjY4NTJWMTMuNTM0NEg4LjAwOTU1VjExLjY4NTJIOS4yNDE3OVoiIGZpbGw9IiMyQjkzOEMiLz4KPC9zdmc+Cg==")
    center no-repeat !important;
}

.step-t2 {
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xNS42IDguOEgxNS4yVjYuMDk3NUMxNS4yIDUuNzggMTUuMDcyNSA1LjQ3NSAxNC44NDc1IDUuMjVMMTIuMzUgMi43NTI1QzEyLjEyNSAyLjUyNzUgMTEuODIgMi40IDExLjUwMjUgMi40SDEwLjRWMS4yQzEwLjQgMC41Mzc1IDkuODYyNSAwIDkuMiAwSDEuMkMwLjUzNzUgMCAwIDAuNTM3NSAwIDEuMlY5LjJDMCA5Ljg2MjUgMC41Mzc1IDEwLjQgMS4yIDEwLjRIMS42QzEuNiAxMS43MjUgMi42NzUgMTIuOCA0IDEyLjhDNS4zMjUgMTIuOCA2LjQgMTEuNzI1IDYuNCAxMC40SDkuNkM5LjYgMTEuNzI1IDEwLjY3NSAxMi44IDEyIDEyLjhDMTMuMzI1IDEyLjggMTQuNCAxMS43MjUgMTQuNCAxMC40SDE1LjZDMTUuODIgMTAuNCAxNiAxMC4yMiAxNiAxMFY5LjJDMTYgOC45OCAxNS44MiA4LjggMTUuNiA4LjhaTTQgMTEuNkMzLjMzNzUgMTEuNiAyLjggMTEuMDYyNSAyLjggMTAuNEMyLjggOS43Mzc1IDMuMzM3NSA5LjIgNCA5LjJDNC42NjI1IDkuMiA1LjIgOS43Mzc1IDUuMiAxMC40QzUuMiAxMS4wNjI1IDQuNjYyNSAxMS42IDQgMTEuNlpNMTIgMTEuNkMxMS4zMzc1IDExLjYgMTAuOCAxMS4wNjI1IDEwLjggMTAuNEMxMC44IDkuNzM3NSAxMS4zMzc1IDkuMiAxMiA5LjJDMTIuNjYyNSA5LjIgMTMuMiA5LjczNzUgMTMuMiAxMC40QzEzLjIgMTEuMDYyNSAxMi42NjI1IDExLjYgMTIgMTEuNlpNMTQgNi40SDEwLjRWMy42SDExLjUwMjVMMTQgNi4wOTc1VjYuNFoiIGZpbGw9IiMyQjkzOEMiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxMi44IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=")
    center no-repeat !important;
}

.step-t3 {
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xNiAzLjU1NTU2TDguODM1NTUgMEwxLjc3Nzc3IDMuNTU1NTZWNC40NDQ0NEgyLjY2NjY2VjcuMTExMTFINC40NDQ0NFY2LjIyMjIySDEzLjMzMzNWMTQuMjIyMkgxNS4xMTExVjQuNDQ0NDRIMTZWMy41NTU1NlpNNS4zMzMzMyA1LjMzMzMzVjQuNDQ0NDRINy4xMTExVjUuMzMzMzNINS4zMzMzM1pNNy45OTk5OSA1LjMzMzMzVjQuNDQ0NDRIOS43Nzc3N1Y1LjMzMzMzSDcuOTk5OTlaTTEwLjY2NjcgNS4zMzMzM1Y0LjQ0NDQ0SDEyLjQ0NDRWNS4zMzMzM0gxMC42NjY3WiIgZmlsbD0iIzJCOTM4QyIvPgo8cGF0aCBkPSJNMTAuNjY2NyA4Ljg4ODg5SDkuNzc3NzdWOEg4Ljg4ODg5VjEwLjY2NjdIMTEuNTU1NlY4SDEwLjY2NjdWOC44ODg4OVoiIGZpbGw9IiMyQjkzOEMiLz4KPHBhdGggZD0iTTEwLjY2NjcgMTIuNDQ0Nkg5Ljc3Nzc3VjExLjU1NTdIOC44ODg4OVYxNC4yMjIzSDExLjU1NTZWMTEuNTU1N0gxMC42NjY3VjEyLjQ0NDZaIiBmaWxsPSIjMkI5MzhDIi8+CjwvZz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAxKSI+CjxwYXRoIGQ9Ik03LjggMTIuMjc3OEg3LjZWMTAuOTY0MUM3LjYgMTAuODA5NyA3LjUzNjI1IDEwLjY2MTUgNy40MjM3NSAxMC41NTIxTDYuMTc1IDkuMzM4MDJDNi4wNjI1IDkuMjI4NjUgNS45MSA5LjE2NjY3IDUuNzUxMjUgOS4xNjY2N0g1LjJWOC41ODMzM0M1LjIgOC4yNjEyOCA0LjkzMTI1IDggNC42IDhIMC42QzAuMjY4NzUgOCAwIDguMjYxMjggMCA4LjU4MzMzVjEyLjQ3MjJDMCAxMi43OTQzIDAuMjY4NzUgMTMuMDU1NiAwLjYgMTMuMDU1NkgwLjhDMC44IDEzLjY5OTcgMS4zMzc1IDE0LjIyMjIgMiAxNC4yMjIyQzIuNjYyNSAxNC4yMjIyIDMuMiAxMy42OTk3IDMuMiAxMy4wNTU2SDQuOEM0LjggMTMuNjk5NyA1LjMzNzUgMTQuMjIyMiA2IDE0LjIyMjJDNi42NjI1IDE0LjIyMjIgNy4yIDEzLjY5OTcgNy4yIDEzLjA1NTZINy44QzcuOTEgMTMuMDU1NiA4IDEyLjk2ODEgOCAxMi44NjExVjEyLjQ3MjJDOCAxMi4zNjUzIDcuOTEgMTIuMjc3OCA3LjggMTIuMjc3OFpNMiAxMy42Mzg5QzEuNjY4NzUgMTMuNjM4OSAxLjQgMTMuMzc3NiAxLjQgMTMuMDU1NkMxLjQgMTIuNzMzNSAxLjY2ODc1IDEyLjQ3MjIgMiAxMi40NzIyQzIuMzMxMjUgMTIuNDcyMiAyLjYgMTIuNzMzNSAyLjYgMTMuMDU1NkMyLjYgMTMuMzc3NiAyLjMzMTI1IDEzLjYzODkgMiAxMy42Mzg5Wk02IDEzLjYzODlDNS42Njg3NSAxMy42Mzg5IDUuNCAxMy4zNzc2IDUuNCAxMy4wNTU2QzUuNCAxMi43MzM1IDUuNjY4NzUgMTIuNDcyMiA2IDEyLjQ3MjJDNi4zMzEyNSAxMi40NzIyIDYuNiAxMi43MzM1IDYuNiAxMy4wNTU2QzYuNiAxMy4zNzc2IDYuMzMxMjUgMTMuNjM4OSA2IDEzLjYzODlaTTcgMTEuMTExMUg1LjJWOS43NUg1Ljc1MTI1TDcgMTAuOTY0MVYxMS4xMTExWiIgZmlsbD0iIzJCOTM4QyIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjE0LjIyMjIiIGhlaWdodD0iMTQuMjIyMiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuNzc3NzcpIi8+CjwvY2xpcFBhdGg+CjxjbGlwUGF0aCBpZD0iY2xpcDEiPgo8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI2LjIyMjIyIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCA4KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=")
    center no-repeat !important;
}

.step-t4 {
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xNS42IDExLjJIMC40MDAwNDFDMC4xNzkwNDEgMTEuMiA0LjA1NDc5ZS0wNSAxMS4zNzkgNC4wNTQ3OWUtMDUgMTEuNlYxMi40QzQuMDU0NzllLTA1IDEyLjYyMSAwLjE3OTA0MSAxMi44IDAuNDAwMDQxIDEyLjhIMTUuNkMxNS44MjEgMTIuOCAxNiAxMi42MjEgMTYgMTIuNFYxMS42QzE2IDExLjM3OSAxNS44MjEgMTEuMiAxNS42IDExLjJaTTIuMDEzNzkgOC41MzE3M0MyLjE3MDc5IDguNzAyNzMgMi4zOTEyOSA4Ljc5OTc0IDIuNjIyMDQgOC43OTk0OUw1Ljg4NTU0IDguNzk0OThDNi4xNDMwOSA4Ljc5NDY0IDYuMzk2OTQgOC43MzM2NiA2LjYyNjU0IDguNjE2OThMMTMuOTAwNSA0LjkyNTczQzE0LjU2OSA0LjU4NjQ4IDE1LjE2ODMgNC4xMDIyNCAxNS41NzYgMy40Njc5OUMxNi4wMzM4IDIuNzU1OTkgMTYuMDgzNSAyLjI0MDczIDE1LjkwMjggMS44NzY3M0MxNS43MjI1IDEuNTEyNDggMTUuMjg0MyAxLjI0NDk4IDE0LjQ0NjUgMS4xOTA0OEMxMy43MDAzIDEuMTQxOTggMTIuOTU4IDEuMzM4NDggMTIuMjg5NSAxLjY3NzQ4TDkuODI2NzkgMi45MjcyM0w0LjM1OTI5IDAuODc1NzM1QzQuMjkzNTUgMC44MzE0NDkgNC4yMTcxOCAwLjgwNTUyNyA0LjEzODA3IDAuODAwNjQ4QzQuMDU4OTUgMC43OTU3NyAzLjk3OTk3IDAuODEyMTEyIDMuOTA5MjkgMC44NDc5ODVMMi4yNjU1NCAxLjY4MjIzQzEuOTk4NzkgMS44MTc0OCAxLjkzNDI5IDIuMTczNDggMi4xMzYyOSAyLjM5NTQ4TDYuMDQxNzkgNC44NDc5OEwzLjQ2MTU0IDYuMTU3NDhMMS42NTI3OSA1LjI0NTczQzEuNTkwNDcgNS4yMTQzMiAxLjUyMTY0IDUuMTk3OTkgMS40NTE4NiA1LjE5ODA4QzEuMzgyMDcgNS4xOTgxNyAxLjMxMzI4IDUuMjE0NjYgMS4yNTEwNCA1LjI0NjIzTDAuMjQ3NzkxIDUuNzU1NDhDLTAuMDEzMjA5NCA1Ljg4Nzk4IC0wLjA4MTk1OTUgNi4yMzM0OCAwLjEwODU0MSA2LjQ1NzQ4TDIuMDEzNzkgOC41MzE3M1oiIGZpbGw9IiMyQjkzOEMiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxMi44IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=")
    center no-repeat !important;
}

.step-t5 {
  background: url("data:image/svg+xml;base64,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")
    center no-repeat !important;
}

.step-t6 {
  background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0xNS42IDguOEgxNS4yVjYuMDk3NUMxNS4yIDUuNzggMTUuMDcyNSA1LjQ3NSAxNC44NDc1IDUuMjVMMTIuMzUgMi43NTI1QzEyLjEyNSAyLjUyNzUgMTEuODIgMi40IDExLjUwMjUgMi40SDEwLjRWMS4yQzEwLjQgMC41Mzc1IDkuODYyNSAwIDkuMiAwSDEuMkMwLjUzNzUgMCAwIDAuNTM3NSAwIDEuMlY5LjJDMCA5Ljg2MjUgMC41Mzc1IDEwLjQgMS4yIDEwLjRIMS42QzEuNiAxMS43MjUgMi42NzUgMTIuOCA0IDEyLjhDNS4zMjUgMTIuOCA2LjQgMTEuNzI1IDYuNCAxMC40SDkuNkM5LjYgMTEuNzI1IDEwLjY3NSAxMi44IDEyIDEyLjhDMTMuMzI1IDEyLjggMTQuNCAxMS43MjUgMTQuNCAxMC40SDE1LjZDMTUuODIgMTAuNCAxNiAxMC4yMiAxNiAxMFY5LjJDMTYgOC45OCAxNS44MiA4LjggMTUuNiA4LjhaTTQgMTEuNkMzLjMzNzUgMTEuNiAyLjggMTEuMDYyNSAyLjggMTAuNEMyLjggOS43Mzc1IDMuMzM3NSA5LjIgNCA5LjJDNC42NjI1IDkuMiA1LjIgOS43Mzc1IDUuMiAxMC40QzUuMiAxMS4wNjI1IDQuNjYyNSAxMS42IDQgMTEuNlpNMTIgMTEuNkMxMS4zMzc1IDExLjYgMTAuOCAxMS4wNjI1IDEwLjggMTAuNEMxMC44IDkuNzM3NSAxMS4zMzc1IDkuMiAxMiA5LjJDMTIuNjYyNSA5LjIgMTMuMiA5LjczNzUgMTMuMiAxMC40QzEzLjIgMTEuMDYyNSAxMi42NjI1IDExLjYgMTIgMTEuNlpNMTQgNi40SDEwLjRWMy42SDExLjUwMjVMMTQgNi4wOTc1VjYuNFoiIGZpbGw9IiMyQjkzOEMiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMCI+CjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxMi44IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=")
    center no-repeat !important;
}

.step-t7 {
  background: url("data:image/svg+xml;base64,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")
    center no-repeat !important;
}

.fix-size {
  white-space: nowrap;
  overflow: hidden;
  width: 200px !important;
  max-width: 200px !important;
}

.fix-size span {
  text-overflow: ellipsis;
}

.fix-size:hover span {
  overflow: visible;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/customs/my-booking.scss";
.bg-transparent {
  background-color: transparent !important;
}
.wr1-booking {
  .vgt-table {
    thead {
      position: sticky;
      top: 0;
    }
  }

  .vgt-table.bordered th {
    border: none;

    &::before {
      content: "";
      position: absolute;
      right: 0;
      top: 0;
      width: 0.1rem;
      /* Độ rộng của đường viền */
      height: 100%;
      background-color: #ddd;
      /* Màu của đường viền */
      pointer-events: none;
    }
  }
}

.card-header .nav-item {
  background-color: rgb(221, 221, 221);

  a {
    color: gray;
    font-weight: 500;
  }
}

.custom_btn_booking {
  padding: 0.6rem 3rem;
  background: #2b938c;
  border: none;
  color: white;
  font-size: large;
  border-radius: 1rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
}

.custom_btn_booking:hover {
  opacity: 0.7;
}

.custom_text_coming {
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  margin-top: 4rem;
}

.container_btn {
  margin-top: -2rem;
  gap: 3.5rem;
  margin-right: 2rem;
  display: flex;
  justify-content: end;
}

[dir] .modal-footer .btn {
  border-radius: 10px;
}

.new-modal-reject.modal-header {
  background-color: #2b938c;
  padding: 0.5rem;

  .modal-title {
    div {
      display: flex;
      justify-content: center;
      color: white;
      font-size: 2rem;
    }
  }

  .close {
    transform: translate(-40px, 20px);
    font-size: 1.5rem;

    &:hover {
      transform: translate(-40px, 20px);
    }
  }

  border-top-left-radius: calc(2.358rem - 1px);
  border-top-right-radius: calc(2.358rem - 1px);

  .header-title {
    font-weight: 600 !important;
  }
}

.inputReject {
  height: 120px;
}

.divReject {
  display: flex;
  justify-content: end;
  margin-top: 1.5rem;
}

.btnReject {
  padding: 0.5rem 1.3rem;
  font-size: 1.2rem;
}

.new-dialog-modal-reject {
  @media (min-width: 576px) {
    max-width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60vh;
  }

  // md --- Medium devices (tablets, 768px and up)
  @media (min-width: 768px) {
    max-width: 90%;
  }

  // lg --- Large devices (desktops, 992px and up)
  @media (min-width: 992px) {
    max-width: 80%;
  }

  //  --- Extra large devices (large desktops, 1200px and up)
  @media (min-width: 1200px) {
    max-width: 80%;
  }

  @media (min-width: 1400px) {
    max-width: 45%;
  }

  .modal-content {
    border-top-left-radius: calc(2.358rem - 1px);
    border-top-right-radius: calc(2.358rem - 1px);
    border-bottom-left-radius: calc(2.358rem - 1px);
    border-bottom-right-radius: calc(2.358rem - 1px);
  }

  .modal-body {
    background-image: url("../../assets/images/misc/bg_choose_service.png");
    height: 200px;
    /* You must set a specified height */
    background-position: center;
    /* Center the image */
    background-repeat: no-repeat;
    /* Do not repeat the image */
    background-size: cover;
    margin: 0;

    .text-black {
      color: #000 !important;
    }

    .title {
      font-weight: bold !important;
      font-size: 1.4rem;
    }
  }
}

.form-control[readonly] {
  background: #fff !important;
}

.form-control[readonly]:disabled {
  background: #f2f2f2 !important;
}

.icons-search {
  position: absolute;
  left: 10px;
}

.flat-picker {
  padding-left: 30px;
}
</style>
